// ============================= //
// STICKY HEADER ON PAGE SCROLL
// ============================= //
(() => {
  const header = document.querySelector('#header-group');
  const topBar = header?.querySelector('.top-bar');

  if (!header || !topBar) return;

  function updateHeader() {
    header.style.setProperty(
      '--rr-top-bar-height',
      `${topBar.getBoundingClientRect().height}px`
    );

    header.classList.toggle('menu-only-visible', window.scrollY > 8);
  }

  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader);
  updateHeader();
})();



// ============================= //
// ADD & REMOVE CLASS FROM BODY & HEADER BASED ON PAGE SCROLL
// ============================= //
$(window).on('scroll', function () {
  if ($(window).scrollTop() > 0) {
    $('body').addClass('whole-page-scrolled');
    $('#header-group').addClass('scrolled');
  } else {
    $('body').removeClass('whole-page-scrolled');
    $('#header-group').removeClass('scrolled');
  }
});

$(document).on('click', '[data-testid="cart-drawer-trigger"]', function () {
  if ($(window).scrollTop() > 0) {
    setTimeout(function () {
      $('#header-group').addClass('scrolled');
    }, 50);

    setTimeout(function () {
      $('#header-group').addClass('scrolled');
    }, 300);
  }
});



// ============================= //
// OPEN DOWNLOAD MENU IN NEW TAB
// ============================= //
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(
    '.header-menu nav[menu-location="main-menu"] .menu-list__list-item:last-child a.menu-list__link, ' +
    '.header-menu nav[menu-location="cms-page"] .menu-list__list-item:last-child a.menu-list__link'
  ).forEach(function (link) {
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
  });
});



// ============================= //
// WELCOME POPUP AFTER HOME PAGE LOAD
// ============================= //
/*document.addEventListener("DOMContentLoaded",function(){
    if(localStorage.getItem("rr_popup_closed")){
      return;
    }

    setTimeout(function(){
      document.getElementById("rrMembershipPopup").classList.add("show");
    },3000);

    document.querySelector(".rr-popup-close").onclick=function(){
        document.getElementById("rrMembershipPopup").classList.remove("show");
        localStorage.setItem("rr_popup_closed","yes");

        setTimeout(function(){
          localStorage.removeItem("rr_popup_closed");
        },604800000); // 7 days
    };
});*/



// ============================= //
// SMOOTH SCROLL TO SECTION
// ============================= //
$(document).ready(function () {
  $('header-menu .menu-list__list-item:nth-child(3) > .menu-list__link')
    .attr('target', '_blank')
    .attr('rel', 'noopener noreferrer');
});

$(document).on('click', 'header-menu .menu-list__list-item a.menu-list__link[href^="#"]', function (e) {
  e.preventDefault();

  var target = $(this).attr('href');

  if ($(target).length) {
    $('html, body').animate({
      scrollTop: $(target).offset().top - 100
    }, 600);

    // Remove #bestsellers from browser URL
    history.replaceState(null, null, window.location.pathname);
  }
});



// ============================= //
// SET EQUAL DIV HEIGHT
// ============================= //
function equalHeight(selector) {
  var maxHeight = 0;

  $(selector).css('height', 'auto');

  $(selector).each(function () {
    var currentHeight = $(this).outerHeight();

    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });

  $(selector).height(maxHeight);
}

function setProductHeights() {
  if ($(window).width() < 768) {
    $('.product-grid .p-name, .product-grid .p-bengali')
      .matchHeight({ remove: true })
      .css('height', '');

    $('.product-grid .p-desc').css({
      'height': 'auto',
      'min-height': '0'
    });

    return;
  }

  $('.product-grid .p-name, .product-grid .p-bengali')
    .matchHeight({ remove: true })
    .css('height', '');

  $('.product-grid .p-desc').css({
    'height': 'auto',
    'min-height': '0'
  });

  equalizeProductNames();
  equalHeight('.location-card .address');
}

function resetProductHeights() {
  $('.product-grid .p-name').matchHeight({
    remove: true
  });

  $('.product-grid .p-bengali').matchHeight({
    remove: true
  });

  $('.product-grid .p-name').css('height', 'auto');
  $('.product-grid .p-bengali').css('height', 'auto');

  $('.product-grid .p-desc').css({
    'height': 'auto',
    'min-height': '0'
  });
}

function equalizeProductNames() {
  $('.product-grid').each(function () {
    var maxHeight = 0;
    var $names = $(this).find('.p-card .p-name');

    $names.css('height', 'auto');

    $names.each(function () {
      maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    $names.height(maxHeight);
  });
}

$(document).ready(function () {
  equalizeProductNames();

  $('.product-grid .p-desc').css({
    'height': 'auto',
    'min-height': '0'
  });
});

$(window).on('load resize', function () {
  setTimeout(function () {
    equalizeProductNames();

    $('.product-grid .p-desc').css({
      'height': 'auto',
      'min-height': '0'
    });
  }, 300);
});



// ============================= //
// COUNTDOWN TIMER
// ============================= //
/*function updateDigits(selector, value) {
  value = String(value).padStart(2, '0');

  const $digits = $(selector).find('.digit');

  if (!$digits.length) return;

  value.split('').forEach(function (num, index) {
    const $digit = $digits.eq(index);

    if (!$digit.length) return;

    if ($digit.text() !== num) {
      $digit.removeClass('animate-up');

      if ($digit[0]) {
        void $digit[0].offsetWidth;
      }

      $digit.text(num);
      $digit.addClass('animate-up');
    }
  });
}

function updateCountdown() {
    const now = new Date();
    const day = now.getDay(); // Sunday=0 ... Saturday=6

    // Hide only on Sunday
    if (day === 0) {
        $('#offer-countdown').hide();
        return;
    }

    $('#offer-countdown').show();

    let target = new Date(now);

    // Saturday = 6
    target.setDate(now.getDate() + (6 - day));
    target.setHours(23, 59, 59, 999);

    const diff = target - now;

    if (diff <= 0) {
        $('#offer-countdown').hide();
        return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff / 3600000) % 24);
    const minutes = Math.floor((diff / 60000) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    updateDigits('#days', days);
    updateDigits('#hours', hours);
    updateDigits('#minutes', minutes);
    updateDigits('#seconds', seconds);

    $('#dayBox').toggle(days > 0);
    $('#hourBox').toggle(hours > 0);
    $('#minuteBox').toggle(minutes > 0);
    $('#secondBox').show();
}

updateCountdown();
setInterval(updateCountdown, 1000);*/



// ============================= //
// WEEKEND PREORDER BUTTON
// ============================= //
function isWeekendPreorderClosed() {
  var now = new Date();
  var day = now.getDay(); // Sunday=0, Saturday=6

  if (day === 0) return true;

  if (day === 6) {
    var closeTime = new Date(now);
    closeTime.setHours(23, 59, 0, 0);

    return now >= closeTime;
  }

  return false;
}

function convertWeekendButtonToWhatsApp($card) {
  var productTitle = $card.attr('data-product-title') || $.trim($card.find('.p-name').text());
  var productPrice = $card.attr('data-product-price') || '';

  var whatsappUrl =
    'https://wa.me/919403890552?text=' +
    encodeURIComponent(
      "Hi, I'm interested in " + productTitle +
      (productPrice ? " (₹" + productPrice + ")" : "") +
      ". Please let me know if I can order it on WhatsApp."
    );

  $card.find('product-form-component').replaceWith(
    '<a href="' + whatsappUrl + '" class="p-order whatsapp-order-btn" target="_blank" rel="noopener noreferrer">WhatsApp Order</a>'
  );

  $card.find('a.p-order').attr('href', whatsappUrl).text('WhatsApp Order');
}

function updateWeekendPreorderButtons() {
  var countdownClosed = isWeekendPreorderClosed();

  $('.product-grid[data-collection="weekend"] .p-card').each(function () {
    var $card = $(this);
    var inventory = parseInt($card.attr('data-inventory'), 10) || 0;

    if (inventory <= 0 || countdownClosed) {
      convertWeekendButtonToWhatsApp($card);
    }
  });
}

$(document).ready(function () {
  updateWeekendPreorderButtons();
});

setInterval(updateWeekendPreorderButtons, 1000);



// ============================= //
// FOOD SIDEBAR CLICK SCROLL + ACTIVE TAB
// ============================= //
$(document).ready(function () {

  var scrollOffset = 140;
  var isClickScrolling = false;

  function setFoodActiveTab(handle) {
    if (!handle) return;

    var $tabs = $('#food-items .food-menu-tab');

    $tabs.removeClass('active');

    var $activeTab = $tabs.filter('[data-food-tab="' + handle + '"]');

    $activeTab.addClass('active');
  }

  function updateFoodActiveTabOnScroll() {
    if (isClickScrolling) return;

    var scrollPoint = $(window).scrollTop() + scrollOffset + 40;
    var activeHandle = '';

    $('#food-items .food-collection-panel').each(function () {
      var $panel = $(this);

      if (scrollPoint >= $panel.offset().top) {
        activeHandle = $panel.attr('data-food-panel');
      }
    });

    setFoodActiveTab(activeHandle);
  }

  $(document).on('click', '#food-items .food-menu-tab', function (e) {
    e.preventDefault();

    var handle = $(this).attr('data-food-tab');
    var $target = $('#food-items .food-collection-panel[data-food-panel="' + handle + '"]');

    if (!$target.length) return;

    isClickScrolling = true;

    setFoodActiveTab(handle);

    $('html, body').stop(true).animate({
      scrollTop: $target.offset().top - scrollOffset
    }, 600, function () {
      setTimeout(function () {
        isClickScrolling = false;
        updateFoodActiveTabOnScroll();
      }, 100);
    });
  });

  $(window).on('scroll resize load', updateFoodActiveTabOnScroll);

  setTimeout(updateFoodActiveTabOnScroll, 300);
  setTimeout(updateFoodActiveTabOnScroll, 1000);
  setTimeout(updateFoodActiveTabOnScroll, 2000);

});



// ============================= //
// DELIVERY PIN CODE VALIDATION
// ============================= //
var serviceablePincodes = [
  '700001','700002','700003','700004','700005','700006','700007','700008','700009',
  '700010','700011','700012','700013','700014','700015','700016','700017','700018',
  '700019','700020','700021','700022','700023','700024','700025','700026','700027',
  '700028','700029','700030','700031','700032','700033','700034','700035','700036',
  '700037','700038','700039','700040','700041','700042','700043','700044','700045',
  '700046','700047','700048','700049','700050','700051','700052','700053','700054',
  '700055','700056','700057','700058','700059','700060','700061','700062','700063',
  '700064','700065','700066','700067','700068','700069','700070','700071','700072',
  '700073','700074','700075','700076','700077','700078','700079','700080','700081',
  '700082','700083','700084','700085','700086','700087','700088','700089','700090',
  '700091','700092','700093','700094','700095','700096','700097','700098','700099',
  '700100','700101','700102','700103','700104','700105','700106','700107','700108',
  '700109','700110','700111','700112','700113','700114','700115','700116','700117',
  '700118','700119','700120','700150','700153'
];

var pendingAction = null;
var pendingButton = null;
var modalAddInProgress = false;

function isPincodeValidated() {
  return localStorage.getItem('ritur_pincode_validated') === 'yes';
}

function saveValidPincode(pin) {
  localStorage.setItem('ritur_pincode_validated', 'yes');
  localStorage.setItem('ritur_pincode', pin);
}

function resetPincodeValidation() {
  localStorage.removeItem('ritur_pincode_validated');
  localStorage.removeItem('ritur_pincode');
}

function continuePendingAction() {
  $('#pincodeModal').fadeOut();

  if (typeof pendingAction === 'function') {
    var action = pendingAction;
    var button = pendingButton;

    pendingAction = null;
    pendingButton = null;

    action(button);
  }
}

function markSavedAddresses() {
  $('.saved-address-item').each(function () {
    var $item = $(this);
    var pin = String($item.attr('data-pin') || '').trim();

    if (serviceablePincodes.includes(pin)) {
      $item.removeClass('disabled');
      $item.find('input[name="saved_address"]').prop('disabled', false);
      $item.find('.address-status').text('');
    } else {
      $item.addClass('disabled');
      $item.find('input[name="saved_address"]').prop('disabled', true);
      $item.find('.address-status').text('Not serviceable');
    }
  });
}

function validateGlobalPincode() {
  var pin = $('#globalPincode').val().trim();

  if (pin.length === 0) {
    $('#globalPincodeMessage').text('Please enter your PIN code.').removeClass('success').addClass('error');
    return false;
  }

  if (pin.length !== 6) {
    $('#globalPincodeMessage').text('Please enter a valid 6-digit PIN code.').removeClass('success').addClass('error');
    return false;
  }

  if (serviceablePincodes.includes(pin)) {
    $('#globalPincodeMessage').text('Delivery available in your area.').removeClass('error').addClass('success');
    saveValidPincode(pin);
    return true;
  }

  $('#globalPincodeMessage').text('Sorry, delivery is not available in your area.').removeClass('success').addClass('error');
  resetPincodeValidation();

  return false;
}

function openPincodeModal(action, button) {
  pendingAction = action;
  pendingButton = button;

  $('#globalPincode').val('');
  $('#globalPincodeMessage').text('').removeClass('success error');
  $('#validatePincodeBtn').prop('disabled', true).addClass('disabled');

  $('input[name="saved_address"]').prop('checked', false);

  markSavedAddresses();

  $('#pincodeModal').fadeIn();
}

$(document).on('input', '#globalPincode', function () {
  this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);

  var pin = this.value;

  $('#validatePincodeBtn').prop('disabled', true).addClass('disabled');

  if (pin.length === 0) {
    $('#globalPincodeMessage').text('').removeClass('success error');
    return;
  }

  if (pin.length < 6) {
    $('#globalPincodeMessage').text('Please enter a valid 6-digit PIN code.').removeClass('success').addClass('error');
    return;
  }

  if (serviceablePincodes.includes(pin)) {
    $('#globalPincodeMessage').text('Delivery available in your area.').removeClass('error').addClass('success');
    $('#validatePincodeBtn').prop('disabled', false).removeClass('disabled');
    return;
  }

  $('#globalPincodeMessage').text('Sorry, delivery is not available in your area.').removeClass('success').addClass('error');
});

$(document).on('click', '#validatePincodeBtn', function () {
  if (!validateGlobalPincode()) return;
  continuePendingAction();
});

$(document).on('change', 'input[name="saved_address"]', function () {
  var pin = String($(this).val() || '').trim();

  if (!serviceablePincodes.includes(pin)) {
    $('#globalPincodeMessage').text('Sorry, delivery is not available in this saved address.').removeClass('success').addClass('error');
    return;
  }

  $('#globalPincode').val(pin);
  saveValidPincode(pin);

  $('#globalPincodeMessage').text('Delivery available in your area.').removeClass('error').addClass('success');

  continuePendingAction();
});

$(document).on('click', '#use-current-location', function () {
  var $btn = $(this);
  var originalText = $btn.html();

  if (!navigator.geolocation) {
    $('#globalPincodeMessage').text('Your browser does not support current location.').removeClass('success').addClass('error');
    return;
  }

  $btn.prop('disabled', true).html('Detecting location...');
  $('#globalPincodeMessage').text('Please allow location access.').removeClass('success error');

  navigator.geolocation.getCurrentPosition(
    function (position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;

      fetch('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + lat + '&lon=' + lng)
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var pin = '';

          if (data && data.address && data.address.postcode) {
            pin = String(data.address.postcode).trim();
          }

          if (!pin) {
            $('#globalPincodeMessage').text('Could not detect your PIN code. Please enter manually.').removeClass('success').addClass('error');
            $btn.prop('disabled', false).html(originalText);
            return;
          }

          $('#globalPincode').val(pin);

          if (serviceablePincodes.includes(pin)) {
            $('#globalPincodeMessage').text('Delivery available in your area. PIN: ' + pin).removeClass('error').addClass('success');
            saveValidPincode(pin);
            $btn.prop('disabled', false).html(originalText);
            continuePendingAction();
          } else {
            resetPincodeValidation();
            $('#globalPincodeMessage').text('Sorry, delivery is not available at your current location. PIN: ' + pin).removeClass('success').addClass('error');
            $('#validatePincodeBtn').prop('disabled', true).addClass('disabled');
            $btn.prop('disabled', false).html(originalText);
          }
        })
        .catch(function () {
          $('#globalPincodeMessage').text('Unable to detect address. Please enter PIN manually.').removeClass('success').addClass('error');
          $btn.prop('disabled', false).html(originalText);
        });
    },
    function () {
      $('#globalPincodeMessage').text('Location permission denied. Please enter PIN manually.').removeClass('success').addClass('error');
      $btn.prop('disabled', false).html(originalText);
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    }
  );
});

$(document).on('click', '.close-pincode-modal', function () {
  $('#pincodeModal').fadeOut();
  pendingAction = null;
  pendingButton = null;
});



// ============================= //
// PRODUCT ADD TO CART BUTTON IN THE PRODUCT MODAL
// ============================= //
$(document).on('click', 'product-form-component button.p-order[name="add"]', function (e) {
  var btn = this;
  var $btn = $(btn);

    if ($btn.data('allow-mixed-check') !== true) {
    e.preventDefault();
    e.stopImmediatePropagation();

    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        if (cartHasWeeklyMeal(cart)) {
          showMixedCartMessage();
          return;
        }

        $btn.data('allow-mixed-check', true);
        btn.click();
      });

    return false;
  }

  $btn.removeData('allow-mixed-check');

  if ($btn.data('allow-submit') === true) {
    $btn.removeData('allow-submit');

    var originalTextAllowed = $btn.data('original-text') || $.trim($btn.text());
    $btn.data('original-text', originalTextAllowed);

    $btn.text('Adding...');

    setTimeout(updateProductCartButtons, 1000);
    setTimeout(updateProductCartButtons, 2500);

    return true;
  }

  if ($('#pincodeModal').length && !isPincodeValidated()) {
    e.preventDefault();
    e.stopImmediatePropagation();

    openPincodeModal(function () {
      $btn.data('allow-submit', true);
      btn.click();
    }, $btn);

    return false;
  }

  setTimeout(updateProductCartButtons, 1000);
  setTimeout(updateProductCartButtons, 2500);
});



// ============================= //
// ADD TO CART
// ============================= //
function addToCart(variantId, quantity, properties) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: String(variantId),
      quantity: quantity,
      properties: properties || {}
    })
  });
}

function refreshCartAfterModalAdd() {
  var sectionId = '';

  var cartItems = document.querySelector('cart-items-component[data-section-id]');

  if (cartItems) {
    sectionId = cartItems.getAttribute('data-section-id');
  }

  if (!sectionId) {
    sectionId = 'sections--20541836984390__header_section';
  }

  return fetch('/?sections=' + sectionId)
    .then(function (response) {
      return response.json();
    })
    .then(function (sections) {
      var html = sections[sectionId];

      if (!html) {
        return fetch('/cart.js');
      }

      var temp = document.createElement('div');
      temp.innerHTML = html;

      var newCartItems = temp.querySelector('cart-items-component');
      var currentCartItems = document.querySelector('cart-items-component');

      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }

      var newDeliveryBox = temp.querySelector('.delivery-schedule-box');
      var currentDeliveryBox = document.querySelector('.delivery-schedule-box');

      if (newDeliveryBox && currentDeliveryBox) {
        currentDeliveryBox.innerHTML = newDeliveryBox.innerHTML;
      }

      var newCartBubble = temp.querySelector('.cart-bubble');
      var currentCartBubble = document.querySelector('.cart-bubble');

      if (newCartBubble && currentCartBubble) {
        currentCartBubble.innerHTML = newCartBubble.innerHTML;
        currentCartBubble.className = newCartBubble.className;
      }

      var newCartDialog = temp.querySelector('.cart-drawer__dialog');
      var currentCartDialog = document.querySelector('.cart-drawer__dialog');

      if (newCartDialog && currentCartDialog) {
        currentCartDialog.className = newCartDialog.className;
        currentCartDialog.setAttribute('aria-labelledby', newCartDialog.getAttribute('aria-labelledby'));
      }

      return fetch('/cart.js');
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      $('.cart-count, [data-cart-count], .cart-count-bubble span, .cart-bubble__text-count').text(cart.item_count);

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:update'));

      updateProductCartButtons();
      refreshDeliveryUIAfterCartChange();

      return cart;
    });
}

function showMixedCartMessage(message) {
    $('#customAlertText').text(
        message || 'Regular food and weekly meal items cannot be ordered together. Please checkout separately.'
    );

    $('#customAlert').addClass('show');
}

$(document).on('click', '#customAlertClose', function(e) {
  e.preventDefault();
  $('#customAlert').removeClass('show');
});

$(document).on('click', '.custom-alert-box', function(e) {
  e.stopPropagation();
});

$(document).on('click', '#customAlert', function(e) {
  e.stopPropagation();
});

function cartHasWeeklyMeal(cart) {
  return cart.items.some(function(item) {
    return String(item.sku || '').endsWith('-daily-meals') || (item.properties && item.properties['Daily Meal Plan'] === 'Yes');
  });
}

function cartHasRegularItems(cart) {
  return cart.items.some(function(item) {
    return !(item.properties && item.properties['Daily Meal Plan'] === 'Yes');
  });
}

$(document).ready(function () {
  fetch('/cart.js')
  .then(function(res){
      return res.json();
  })
  .then(function(cart){
      window.cartItemsData = cart.items;
  });
});



// ============================= //
// PINCODE HANDLER FOR MODAL BUTTON
// ============================= //
$(document).on('click', '.open-order-modal', function (e) {
  e.preventDefault();

  var $btn = $(this);

  if (
    $btn.hasClass('require-pincode') &&
    $('#pincodeModal').length &&
    !isPincodeValidated()
  ) {
    openPincodeModal(function () {
      openProductModal($btn);
    }, $btn);

    return;
  }

  openProductModal($btn);
});



// ============================= //
// PRODUCT MODAL - SHOPIFY OPTION VARIANTS + ADDON PRODUCTS
// ============================= //
function openProductModal($btn) {
  var product = $btn.attr('data-product') || '';
  var image = $btn.attr('data-image') || '';
  var defaultVariantId = String($btn.attr('data-variant-id') || '').trim();
  var defaultPrice = parseInt($btn.attr('data-price'), 10) || 0;
  var addonMapData = $btn.attr('data-addon-map') || '';

  modalAddInProgress = false;

  $('#modalProduct').val(product);
  $('#modalProductDisplay').val(product);
  $('#customerQty').val(1);

  $('#modalVariantId').val(defaultVariantId);
  $('#modalBasePrice').val(defaultPrice);
  $('#modalFinalPrice').val(defaultPrice);
  $('#modalTotalPrice').text(formatMoney(defaultPrice));

  $('#modalAddonMap').val(addonMapData);
  $('#foodAddonGroups').html('');
  $('#foodAddonWrapper').hide();

  $('#modalBuyNow')
    .text('Add to Cart')
    .prop('disabled', false)
    .removeClass('in-cart');

  if (addonMapData !== '') {
    try {
      var addonMap = JSON.parse(addonMapData);

      if (addonMap && addonMap.groups && addonMap.groups.length > 0) {
        renderFoodAddons(addonMap);

        setTimeout(function () {
          syncAddonSelectionsFromCart(product);
        }, 100);
      }
    } catch (e) {
      console.log('Addon JSON error:', e);
      console.log('Addon data:', addonMapData);
    }
  }

  $('#modalProductImage').hide().attr('src', '').attr('alt', '');

  if (image) {
    $('#modalProductImage').attr('src', image).attr('alt', product).fadeIn(100);
  }

  updateModalPrice();
  updateModalButtonState();

  $('#productOrderModal').fadeIn();
}

function renderFoodAddons(data) {
  $('#foodAddonGroups').html('');

  if (!data || !data.groups || !data.groups.length) {
    $('#foodAddonWrapper').hide();
    return;
  }

  var html = '';

  data.groups.forEach(function (group, groupIndex) {
    html += `
      <div class="addon-group" data-group-index="${groupIndex}">
        <h4>
          ${group.title}
          <span class="addon-count" data-group-count="${groupIndex}">
            0/${group.max_selection || '∞'}
          </span>
        </h4>
        <div class="addon-box">
    `;

    group.options.forEach(function (item) {
      if (String(item.value).trim() === 'Regular') return;

      var priceText = item.price && item.price > 0 ? '+ ₹' + item.price : '';

      html += `
        <label class="addon-item d-flex">
          <span class="fill-column"><i class="bi bi-dot"></i> ${item.name}</span>

          <div class="addon-right auto-column">
            <span>${priceText}</span>

            <input
              type="checkbox"
              name="addon_group_${groupIndex}"
              class="custom-extra-option"
              data-group="${groupIndex}"
              data-name="${item.name}"
              data-value="${item.value}"
              data-price="${item.price * 100}"
              data-variant-id="${item.variant_id || ''}">
          </div>
        </label>
      `;
    });

    html += `
        </div>
      </div>
    `;
  });

  $('#foodAddonGroups').html(html);
  $('#foodAddonWrapper').show();

  updateAddonGroupCounts();
}

function formatMoney(cents) {
  return '₹' + (parseInt(cents, 10) / 100).toFixed(2);
}

function getAddonMap() {
  var addonMapData = $('#modalAddonMap').val() || '{}';

  try {
    return JSON.parse(addonMapData);
  } catch (e) {
    console.log('Addon map parse error:', e);
    return {};
  }
}

function syncAddonSelectionsFromCart(productName) {
  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      $('.custom-extra-option').prop('checked', false);

      cart.items.forEach(function (item) {
        var addonFor = item.properties && item.properties['_Addon For'];

        if (addonFor === productName) {
          $('.custom-extra-option[data-variant-id="' + item.variant_id + '"]')
            .prop('checked', true);
        }
      });

      updateAddonGroupCounts();
      updateModalPrice();
    });
}

function updateModalButtonState() {
  var mainVariantId = $('#modalVariantId').val();

  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var exists = cart.items.some(function (item) {
        var isAddon = item.properties && item.properties['_Addon For'];
        return String(item.variant_id) === String(mainVariantId) && !isAddon;
      });

      if (exists) {
        $('#modalBuyNow')
          .text('Add to Cart')
          .prop('disabled', false)
          .removeClass('in-cart');
      } else {
        $('#modalBuyNow')
          .text('Add to Cart')
          .prop('disabled', false)
          .removeClass('in-cart');
      }
    });
}

function updateModalPrice() {
  var qty = parseInt($('#customerQty').val(), 10) || 1;
  var basePrice = parseInt($('#modalBasePrice').val(), 10) || 0;
  var addonTotal = 0;

  $('.custom-extra-option:checked').each(function () {
    addonTotal += parseInt($(this).attr('data-price'), 10) || 0;
  });

  var finalPrice = basePrice + addonTotal;

  $('#modalFinalPrice').val(finalPrice);
  $('#modalTotalPrice').text(formatMoney(finalPrice * qty));
}

function updateAddonGroupCounts() {
  var addonMap = getAddonMap();

  if (!addonMap || !addonMap.groups) return;

  addonMap.groups.forEach(function (group, groupIndex) {
    var maxSelection = parseInt(group.max_selection, 10) || 999;
    var checkedCount = $('.custom-extra-option[data-group="' + groupIndex + '"]:checked').length;

    $('[data-group-count="' + groupIndex + '"]').text(checkedCount + '/' + maxSelection);

    var limitReached = checkedCount >= maxSelection;

    $('.custom-extra-option[data-group="' + groupIndex + '"]').each(function () {
      if (!$(this).is(':checked')) {
        $(this).prop('disabled', limitReached);
        $(this).closest('.addon-item').toggleClass('disabled', limitReached);
      } else {
        $(this).prop('disabled', false);
        $(this).closest('.addon-item').removeClass('disabled');
      }
    });
  });
}

$(document).on('change', '.custom-extra-option', function () {
  updateAddonGroupCounts();
  updateModalPrice();
});

$(document).on('input change', '#customerQty', function () {
  updateModalPrice();
});

$(document).on('click', '.close-product-modal', function () {
  $('#productOrderModal').fadeOut();
  $('#modalProductImage').hide().attr('src', '').attr('alt', '');
  modalAddInProgress = false;
});

$(document).on('click', '#modalBuyNow', function () {
  if (modalAddInProgress) return;

  var mainVariantId = $('#modalVariantId').val();
  var quantity = parseInt($('#customerQty').val(), 10) || 1;
  var productName = $('#modalProduct').val();

  if (!mainVariantId) {
    alert('No product variant found.');
    return;
  }

  modalAddInProgress = true;
  $('#modalBuyNow').text('Adding...');

  fetch('/cart.js')
  .then(function(response) {
    return response.json();
  })
  .then(function(cart) {
    window.cartItemsData = cart.items;

    if (cartHasWeeklyMeal(cart)) {
      showMixedCartMessage();

      $('#modalBuyNow')
        .text('Add to Cart')
        .prop('disabled', false)
        .removeClass('in-cart');

      modalAddInProgress = false;

      throw 'mixed-cart';
    }
  });

  var addonGroupKey = 'addon_' + Date.now();

  fetch('/cart.js')
  .then(function (response) {
    return response.json();
  })
  .then(function (cart) {

    if (cartHasWeeklyMeal(cart)) {
      showMixedCartMessage();

      $('#modalBuyNow')
        .text('Add to Cart')
        .prop('disabled', false)
        .removeClass('in-cart');

      modalAddInProgress = false;

      throw 'mixed-cart';
    }

    var items = [];
    var existingMainGroupKey = '';

      cart.items.forEach(function (item) {
        var isMainProduct =
          item.properties && item.properties['_Main Product'] === 'Yes';

        if (
          String(item.variant_id) === String(mainVariantId) &&
          isMainProduct
        ) {
          existingMainGroupKey = item.properties['_Addon Group'];
        }
      });

      var finalGroupKey = existingMainGroupKey || addonGroupKey;

      if (!existingMainGroupKey) {
        items.push({
          id: Number(mainVariantId),
          quantity: quantity,
          properties: {
            '_Main Product': 'Yes',
            '_Addon Group': finalGroupKey
          }
        });
      }

      $('.custom-extra-option:checked').each(function () {
        var addonVariantId = $(this).attr('data-variant-id');

        if (addonVariantId) {
          items.push({
            id: Number(addonVariantId),
            quantity: quantity,
            properties: {
              '_Addon For': productName,
              '_Addon Group': finalGroupKey
            }
          });
        }
      });

      if (!items.length) {
        $('#modalBuyNow').text('Add to Cart');
        modalAddInProgress = false;
        return null;
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      });
    })
    .then(function (response) {
      if (!response) return null;

      return response.json().then(function (data) {
        if (!response.ok) {
          throw data;
        }

        return data;
      });
    })
    .then(function () {
      return refreshCartAfterModalAdd();
    })
    .then(function () {
      $('#modalBuyNow')
        .text('Add to Cart')
        .prop('disabled', false)
        .removeClass('in-cart');

      $('#productOrderModal').fadeOut();
      $('#modalProductImage').hide().attr('src', '').attr('alt', '');

      updateProductCartButtons();

      setTimeout(updateProductCartButtons, 800);
      setTimeout(updateProductCartButtons, 1800);

      modalAddInProgress = false;

      var drawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        var drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

        if (drawerTrigger) {
          drawerTrigger.click();
        }
      }
    })
    .catch(function (error) {
      if (error === 'mixed-cart') return;

      alert(error && error.description ? error.description : 'Something went wrong.');

      $('#modalBuyNow')
        .text('Add to Cart')
        .prop('disabled', false)
        .removeClass('in-cart');

      modalAddInProgress = false;
    });
});



// ============================= //
// REMOVE ORPHAN ADDONS IF MAIN PRODUCT IS REMOVED
// ============================= //
$(document).on(
  'click',
  'cart-remove-button, cart-remove-button button, .cart-remove-button, a[href*="/cart/change"], button[name="minus"], .quantity__button[name="minus"]',
  function () {
    saveDeliveryState();
  }
);

var addonCleanupRunning = false;

function cleanupOrphanAddonProducts() {
  if (addonCleanupRunning) return;

  addonCleanupRunning = true;

  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var activeMainGroups = {};
      var updates = {};

      cart.items.forEach(function (item) {
        var groupKey = item.properties && item.properties['_Addon Group'];
        var isMainProduct = item.properties && item.properties['_Main Product'] === 'Yes';

        if (groupKey && isMainProduct) {
          activeMainGroups[groupKey] = true;
        }
      });

      cart.items.forEach(function (item) {
        var groupKey = item.properties && item.properties['_Addon Group'];
        var addonFor = item.properties && item.properties['_Addon For'];

        if (groupKey && addonFor && !activeMainGroups[groupKey]) {
          updates[item.key] = 0;
        }
      });

      if (!Object.keys(updates).length) return null;

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updates
        })
      });
    })
    .then(function () {
      addonCleanupRunning = false;
      updateProductCartButtons();
    })
    .catch(function () {
      addonCleanupRunning = false;
    });
}

$(document).on(
  'click',
  'cart-remove-button, cart-remove-button button, .cart-remove-button, a[href*="/cart/change"], button[name="minus"], .quantity__button[name="minus"]',
  function () {
    setTimeout(function () {
      cleanupOrphanAddonProducts();
    }, 1200);

    setTimeout(function () {
      cleanupOrphanAddonProducts();
      refreshCartAfterModalAdd();
    }, 2200);
  }
);



// ============================= //
// DELIVERY SCHEDULE OPTIONS
// ============================= //
function isPreOrderSelected() {
  return $('#preOrderDelivery').is(':checked');
}

function isInstantDeliverySelected() {
  return $('#instantDelivery').is(':checked');
}

var deliverySlots = (window.deliverySlotsFromTheme || []).sort(function (a, b) {
  return a.start - b.start;
});

function getCurrentMinutes() {
  var now = new Date();
  return now.getHours() * 60 + now.getMinutes();
}

function getDateValueFromOffset(days) {
  var date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + days);

  var yyyy = date.getFullYear();
  var mm = String(date.getMonth() + 1).padStart(2, '0');
  var dd = String(date.getDate()).padStart(2, '0');

  return yyyy + '-' + mm + '-' + dd;
}

function cartHasWeekendSale() {
    return window.cartItemsData && window.cartItemsData.some(function(item) {
        return item.properties && item.properties['_Weekend Sale'] === 'Yes';
    });
}

function getMondayOfCurrentWeek() {
    var date = new Date();
    var day = date.getDay();

    var diff = (day === 0 ? -6 : 1 - day);

    date.setDate(date.getDate() + diff);
    date.setHours(0,0,0,0);

    return date;
}

function formatDate(date){
    return date.toISOString().split('T')[0];
}

function formatDateForDisplay(dateValue) {
  if (!dateValue) return '';

  var parts = dateValue.split('-');
  if (parts.length !== 3) return dateValue;

  return parts[2] + '-' + parts[1] + '-' + parts[0];
}

function convertTimeToMinutes(timeValue) {
  var parts = String(timeValue).split(':');
  var hour = parseInt(parts[0], 10) || 0;
  var minute = parseInt(parts[1], 10) || 0;

  return hour * 60 + minute;
}

function isInstantDeliveryAvailableNow() {
  var currentMinutes = getCurrentMinutes();
  return currentMinutes >= 10 * 60 && currentMinutes < 22 * 60;
}

// Skip current and next 1 slot = next 2 slots disabled
function getTodayAllowedSlots() {
  var currentMinutes = getCurrentMinutes();

  var upcomingSlots = deliverySlots.filter(function (slot) {
    return slot.start >= currentMinutes;
  });

  return upcomingSlots.slice(2);
}

function hasAvailableSlotsToday() {
  return getTodayAllowedSlots().length > 0;
}

function shouldForcePreorderTomorrow() {
  return $('#forcePreorderTomorrow').val() === 'yes';
}

function getPreOrderMinOffset() {
  // Skip today and tomorrow, then offer seven selectable dates.
  return 2;
}

function updateDeliveryDateLimit() {
  var minDate = getDateValueFromOffset(getPreOrderMinOffset());
  var maxDate = getDateValueFromOffset(getPreOrderMinOffset() + 6);

  $('#deliveryDate')
    .prop('disabled', false)
    .attr('min', minDate)
    .attr('max', maxDate);

  var selectedDate = $('#deliveryDate').val();
  if (selectedDate && (selectedDate < minDate || selectedDate > maxDate)) {
    $('#deliveryDate').val('');
    $('#deliveryTime').val('');
  }
}

function getDateValue(date) {
  var yyyy = date.getFullYear();
  var mm = String(date.getMonth() + 1).padStart(2, '0');
  var dd = String(date.getDate()).padStart(2, '0');

  return yyyy + '-' + mm + '-' + dd;
}

function getDateValue(date) {
    return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
    ].join('-');
}

function getDateValue(date) {
  var yyyy = date.getFullYear();
  var mm = String(date.getMonth() + 1).padStart(2, '0');
  var dd = String(date.getDate()).padStart(2, '0');

  return yyyy + '-' + mm + '-' + dd;
}

function getDateValue(date) {
  var yyyy = date.getFullYear();
  var mm = String(date.getMonth() + 1).padStart(2, '0');
  var dd = String(date.getDate()).padStart(2, '0');

  return yyyy + '-' + mm + '-' + dd;
}

function updateAvailableTimeSlots() {
  var selectedDate = $('#deliveryDate').val();
  var todayDate = getDateValueFromOffset(0);
  var minOffset = getPreOrderMinOffset();

  $('#deliveryTime option').prop('disabled', false).show();

  if (!selectedDate) {
    $('#deliveryTime').val('');
    return;
  }

  // If selected date is today, disable next 2 slots from current time
  if (selectedDate === todayDate && minOffset === 0) {
    var allowedToday = getTodayAllowedSlots().map(function (slot) {
      return slot.value;
    });

    $('#deliveryTime option').each(function () {
      var optionValue = $(this).val();

      if (!optionValue) return;

      if (!allowedToday.includes(optionValue)) {
        $(this).prop('disabled', true).hide();
      }
    });
  }

  if ($('#deliveryTime option:selected').is(':disabled')) {
    $('#deliveryTime').val('');
  }
}

function updateInstantDeliveryAvailability() {
  if (isWeeklyMealCart) { rrShowDailySchedule(); return; }
  var $instantOption = $('.instant-delivery-option');
  var $instantRadio = $('#instantDelivery');
  var $preorderRadio = $('#preOrderDelivery');
  var $closedMessage = $('#instantOrderClosedMessage');

  if (shouldForcePreorderTomorrow()) {
    $('body').removeClass('instant-delivery-closed');

    $closedMessage.hide();
    $instantOption.show();
    $instantRadio.prop('checked', false).prop('disabled', true);
    $preorderRadio.prop('checked', true);

    $('#scheduleFields').show();
    $('#deliveryDate, #deliveryTime').prop('required', true);

    updateDeliveryDateLimit();
    updateAvailableTimeSlots();
    toggleScheduleFields();
    return;
  }

  if (isInstantDeliveryAvailableNow()) {
    $('body').removeClass('instant-delivery-closed');
    $closedMessage.hide();

    if (!$instantRadio.is(':disabled')) {
      $instantOption.show();
    }
  } else {
    $('body').addClass('instant-delivery-closed');

    $closedMessage.show();
    $instantOption.hide();
    $instantRadio.prop('checked', false).prop('disabled', true);
    $preorderRadio.prop('checked', true);

    $('#scheduleFields').show();
    $('#deliveryDate, #deliveryTime').prop('required', true);
  }

  toggleScheduleFields();
}

// ====================================
// UPDATE INSTANT ORDER NOTICE ON DRAWER OPEN
// ====================================
$(function () {
  function refreshInstantNotice() {
    if (document.getElementById('instantDelivery')) {
      updateInstantDeliveryAvailability();
    }
  }

  // Update immediately when the cart icon is clicked.
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-testid="cart-drawer-trigger"]')) {
      refreshInstantNotice();
    }
  }, true);

  // Update before the drawer becomes visible.
  document.addEventListener('beforetoggle', function (event) {
    if (
      event.target.matches('.cart-drawer__dialog') &&
      event.newState === 'open'
    ) {
      refreshInstantNotice();
    }
  }, true);

  // Handle programmatic opening and newly rendered cart content.
  var observer = new MutationObserver(function (records) {
    var needsRefresh = records.some(function (record) {
      if (record.type === 'attributes') {
        return record.target.matches('.cart-drawer__dialog[open]');
      }

      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (
          node.matches('#instantDelivery, #instantOrderClosedMessage') ||
          node.querySelector('#instantDelivery, #instantOrderClosedMessage')
        );
      });
    });

    if (needsRefresh) {
      refreshInstantNotice();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  refreshInstantNotice();

  // Keep checking the time while the page remains open.
  setInterval(refreshInstantNotice, 15000);
});

function toggleScheduleFields() {
  if (isWeeklyMealCart) { rrShowDailySchedule(); return; }
  var isWeekly = false;

  if ($('#preOrderDelivery').is(':checked')) {
    $('#scheduleFields').slideDown(200);

    if (isWeekly) {
      $('.normal-delivery-fields').hide();
      $('#weeklyMealTimeFields').show();

      $('#deliveryDate, #deliveryTime').prop('required', false).val('');
      $('#weeklyDeliveryDate, #weeklyLunchTime, #weeklyDinnerTime').prop('required', true);

      generateWeeklyMealWeeks();
    } else {
      $('.normal-delivery-fields').show();
      $('#weeklyMealTimeFields').hide();

      $('#deliveryDate, #deliveryTime').prop('required', true);
      $('#weeklyDeliveryDate, #weeklyLunchTime, #weeklyDinnerTime')
        .prop('required', false)
        .val('');

      updateDeliveryDateLimit();
      updateAvailableTimeSlots();
    }
  } else {
    $('#scheduleFields').slideUp(200);

    $('.normal-delivery-fields').hide();
    $('#weeklyMealTimeFields').hide();

    $('#deliveryDate, #deliveryTime, #weeklyDeliveryDate, #weeklyLunchTime, #weeklyDinnerTime')
      .prop('required', false)
      .val('');

    $('#deliveryScheduleMessage').text('');
  }

  updateCheckoutButtonState();
}

function validateDeliverySchedule() {
  if (isWeeklyMealCart) {
    const dates = new Set((rrDailyScheduleCart?.items || []).map(i => {
      const raw=i.properties?.['Delivery date'];if(!raw)return '';
      const d=new Date(raw+'T00:00:00Z');if(!Number.isFinite(d.getTime()))return '';
      d.setUTCDate(d.getUTCDate()-d.getUTCDay());return d.toISOString().slice(0,10);
    }));
    if (dates.size !== 1 || dates.has('')) {
      $('#deliveryScheduleMessage').text('Please keep meals from one valid delivery week in this cart.').css('color','#FF4F00');
      return false;
    }
    var weeklyDate = $('#weeklyDeliveryDate').val();
    var lunchTime = $('#weeklyLunchTime').val();
    var dinnerTime = $('#weeklyDinnerTime').val();

    if (!weeklyDate) {
      $('#deliveryScheduleMessage')
        .text('Please select your weekly meal week.')
        .css('color', '#FF4F00');

      $('#weeklyDeliveryDate').focus();
      return false;
    }

    if (!lunchTime || !dinnerTime) {
      $('#deliveryScheduleMessage')
        .text('Please select both weekly meal delivery times: Lunch and Dinner.')
        .css('color', '#FF4F00');

      $('#weeklyLunchTime').focus();
      return false;
    }

    $('#deliveryScheduleMessage')
      .text('Weekly meal delivery schedule selected.')
      .css('color', '#40bc68');

    return true;
  }

  if (!isPreOrderSelected()) {
    if (!isInstantDeliveryAvailableNow()) {
      $('#deliveryScheduleMessage')
        .text('Instant Delivery is available only between 10:00 AM and 10:00 PM. Please select Pre-Order.')
        .css('color', '#FF4F00');

      $('#instantDelivery').prop('checked', false);
      $('#preOrderDelivery').prop('checked', true);

      updateInstantDeliveryAvailability();

      return false;
    }

    return true;
  }

  updateDeliveryDateLimit();
  updateAvailableTimeSlots();

  var date = $('#deliveryDate').val();
  var time = $('#deliveryTime').val();

  if (!date || !time) {
    $('#deliveryScheduleMessage')
      .text('Please select your preferred delivery date and time.')
      .css('color', '#FF4F00');

    if (!date) {
      $('#deliveryDate').focus();
    } else {
      $('#deliveryTime').focus();
    }

    return false;
  }

  var minOffset = getPreOrderMinOffset();
  var minDate = getDateValueFromOffset(minOffset);
  var maxDate = getDateValueFromOffset(minOffset + 6);

  if (date < minDate || date > maxDate) {
    $('#deliveryScheduleMessage')
      .text('Please select a delivery date from 2 to 8 days from today.')
      .css('color', '#FF4F00');

    $('#deliveryDate').val('').focus();
    return false;
  }

  if ($('#deliveryTime option:selected').is(':disabled')) {
    $('#deliveryScheduleMessage')
      .text('This delivery time is no longer available. Please select another time.')
      .css('color', '#FF4F00');

    $('#deliveryTime').val('').focus();
    return false;
  }

  $('#deliveryScheduleMessage')
    .text('Delivery schedule selected.')
    .css('color', '#40bc68');

  return true;
}

function saveDeliveryScheduleToCart() {
  var cutleryRequired = $('input[name="attributes[Cutlery Required]"]:checked').val() || '';

  var deliveryType = isPreOrderSelected() ? 'Pre-Order' : 'Instant Delivery';

  var rawDate = isPreOrderSelected() ? $('#deliveryDate').val() : '';
  var formattedDate = rawDate ? formatDateForDisplay(rawDate) : '';

  var time = isPreOrderSelected() ? $('#deliveryTime').val() : '';

  var formattedDelivery = formattedDate && time
    ? formattedDate + ' | ' + time
    : '';

  if (isWeeklyMealCart) {
    var weeklyDate = $('#weeklyDeliveryDate').val();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Cutlery Required': $('input[name="attributes[Cutlery Required]"]:checked').val(),
          'Delivery Type': 'Weekly Meal Pre-Order',
          'Weekly Meal Week': weeklyDate,
          'Weekly Lunch Time': $('#weeklyLunchTime').val(),
          'Weekly Dinner Time': $('#weeklyDinnerTime').val(),
          'Selected Delivery Date & Time': weeklyDate,
          'Delivery Note': 'Weekly meal order'
        }
      })
    });
  }

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        'Cutlery Required': cutleryRequired,
        'Delivery Type': deliveryType,
        'Selected Delivery Date & Time': formattedDelivery,
        'Delivery Note': isInstantDeliverySelected()
          ? 'Delivery scheduled 1 hour after the order is placed.'
          : ''
      }
    })
  });
}

$(document).ready(function () {
  updateDeliveryDateLimit();

  $('#instantDelivery').prop('checked', false);
  $('#preOrderDelivery').prop('checked', false);

  $('#scheduleFields').hide();

  updateInstantDeliveryAvailability();
});

$(document).on('change', 'input[name="attributes[Delivery Type]"]', function () {
  toggleScheduleFields();
});

$(document).on('change input', '#deliveryDate', function () {
  updateDeliveryDateLimit();
  updateAvailableTimeSlots();
  $('#deliveryScheduleMessage').text('').css('color', '');
});

$(document).on('change input', '#deliveryTime', function () {
  $('#deliveryScheduleMessage').text('').css('color', '');
});

var isWeeklyMealCart = false;
var rrDailyScheduleCart = null;

function checkWeeklyMealCart() {
  return fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      rrDailyScheduleCart = cart;
      isWeeklyMealCart = cart.items.some(function(item) {
        return String(item.sku || '').endsWith('-daily-meals') || (item.properties && item.properties['Daily Meal Plan'] === 'Yes');
      });

      if (!isWeeklyMealCart && cart.attributes && cart.attributes['Weekly Order'] === 'Yes') {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Weekly Order': ''
            }
          })
        }).then(function() {
          updateWeeklyMealDeliveryUI();
          return false;
        });
      }

      updateWeeklyMealDeliveryUI();
      return isWeeklyMealCart;
    });
}

function updateWeeklyMealDeliveryUI() {
  if (isWeeklyMealCart) {
    rrShowDailySchedule();
  } else {
    document.body.classList.remove('rr-daily-schedule-active');
    $('#preOrderDelivery').prop('disabled', false);
    $('.preorder-delivery-option').show();
    $('#weeklyMealTimeFields').hide();
    $('#weeklyDeliveryDate, #weeklyLunchTime, #weeklyDinnerTime').prop('required', false);
    $('#deliveryTime').show();
    updateInstantDeliveryAvailability();
  }
  updateCheckoutButtonState();
}

$(document).on('click', '[name="checkout"], .checkout-btn', function (e) {
  e.preventDefault();

  updateDeliveryDateLimit();
  updateInstantDeliveryAvailability();

  if (!validateDeliverySchedule()) {
    return;
  }

  saveDeliveryScheduleToCart().then(function () {
    window.location.href = '/checkout';
  });
});

$(document).ready(function () {
  checkWeeklyMealCart();
});

document.addEventListener('cart:refresh', refreshDeliveryUIAfterCartChange);
document.addEventListener('cart:update', refreshDeliveryUIAfterCartChange);



// ============================= //
// BLOCK CHECKOUT UNTIL REQUIRED OPTIONS SELECTED
// ============================= //
function isCartReadyForCheckout() {

  var deliverySelected =
    document.querySelector('input[name="attributes[Delivery Type]"]:checked');

  /*
   * Cutlery is OPTIONAL.
   * No validation is required here.
   */

  if (!deliverySelected) {
    $('#deliveryScheduleMessage')
      .text('Please select your delivery option.')
      .css('color', '#FF4F00');

    $('.delivery-schedule-box')[0]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    return false;
  }

  if ($('#preOrderDelivery').is(':checked')) {

    if (isWeeklyMealCart) {

      if (
        !$('#weeklyDeliveryDate').val() ||
        !$('#weeklyLunchTime').val() ||
        !$('#weeklyDinnerTime').val()
      ) {
        $('#deliveryScheduleMessage')
          .text('Please select weekly meal week, lunch time and dinner time.')
          .css('color', '#FF4F00');

        return false;
      }

      return validateDeliverySchedule();
    }

    var date = $('#deliveryDate').val();
    var time = $('#deliveryTime').val();

    if (!date || !time) {
      $('#deliveryScheduleMessage')
        .text('Please select your preferred delivery date and time.')
        .css('color', '#FF4F00');

      if (!date) {
        $('#deliveryDate').focus();
      } else {
        $('#deliveryTime').focus();
      }

      return false;
    }
  }

  return validateDeliverySchedule();
}

function updateCheckoutButtonState() {

  /*
   * Cutlery is OPTIONAL.
   * Only delivery option is required.
   */
  var deliverySelected =
    $('input[name="attributes[Delivery Type]"]:checked').length > 0;

  var isWeekly =
    $('#weeklyMealTimeFields').is(':visible') ||
    $('body').hasClass('weekly-order-active');

  var isValid = deliverySelected;

  if (isWeekly) {

    isValid =
      isValid &&
      $('#weeklyDeliveryDate').val() &&
      $('#weeklyLunchTime').val() &&
      $('#weeklyDinnerTime').val();

  } else if ($('#preOrderDelivery').is(':checked')) {

    isValid =
      isValid &&
      $('#deliveryDate').val() &&
      $('#deliveryTime').val();
  }

  $('#checkout, button[name="checkout"], .cart__checkout-button')
    .prop('disabled', !isValid)
    .attr('aria-disabled', !isValid)
    .toggleClass('disabled', !isValid);
}

var savedDeliveryState = {};

function saveDeliveryState() {
  savedDeliveryState = {
    cutlery: $('input[name="attributes[Cutlery Required]"]:checked').val() || '',
    deliveryType: $('input[name="attributes[Delivery Type]"]:checked').val() || '',
    deliveryDate: $('#deliveryDate').val() || '',
    deliveryTime: $('#deliveryTime').val() || '',
    weeklyWeek: $('#weeklyDeliveryDate').val() || '',
    weeklyLunch: $('#weeklyLunchTime').val() || '',
    weeklyDinner: $('#weeklyDinnerTime').val() || ''
  };
}

function restoreDeliveryState() {
  if (savedDeliveryState.cutlery) {
    $('input[name="attributes[Cutlery Required]"][value="' + savedDeliveryState.cutlery + '"]').prop('checked', true);
  }

  if (savedDeliveryState.deliveryType) {
    $('input[name="attributes[Delivery Type]"][value="' + savedDeliveryState.deliveryType + '"]').prop('checked', true);
  }

  $('#deliveryDate').val(savedDeliveryState.deliveryDate);
  $('#deliveryTime').val(savedDeliveryState.deliveryTime);
  $('#weeklyDeliveryDate').val(savedDeliveryState.weeklyWeek);
  $('#weeklyLunchTime').val(savedDeliveryState.weeklyLunch);
  $('#weeklyDinnerTime').val(savedDeliveryState.weeklyDinner);
}

function refreshDeliveryUIAfterCartChange() {
  setTimeout(function () {
    checkWeeklyMealCart().then(function () {
      updateCheckoutButtonState();
    });
  }, 500);

  setTimeout(function () {
    checkWeeklyMealCart().then(function () {
      updateCheckoutButtonState();
    });
  }, 1500);
}

// Capture click BEFORE Shopify theme handles checkout
document.addEventListener('click', function (e) {
  var checkoutBtn = e.target.closest('#checkout, button[name="checkout"], .cart__checkout-button');

  if (!checkoutBtn) return;
  if (document.querySelector('#rr-wallet-checkout-pilot') && isWeeklyMealCart) return;

  if (!isCartReadyForCheckout()) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    updateCheckoutButtonState();
    return false;
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  saveDeliveryScheduleToCart().then(function () {
    window.location.href = '/checkout';
  });

}, true);

// Block cart form submit also
document.addEventListener('submit', function (e) {
  if (!e.target.matches('#cart-form')) return;

  if (!isCartReadyForCheckout()) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    updateCheckoutButtonState();
    return false;
  }
}, true);

$(document).on(
  'change input',
  'input[name="attributes[Cutlery Required]"], input[name="attributes[Delivery Type]"], #deliveryDate, #deliveryTime, #weeklyDeliveryDate, #weeklyLunchTime, #weeklyDinnerTime',
  function () {
    $('#deliveryScheduleMessage').text('').css('color', '');
    updateCheckoutButtonState();
  }
);

$(document).ready(function () {
  setTimeout(updateCheckoutButtonState, 300);
});

document.addEventListener('cart:refresh', function () {
  setTimeout(updateCheckoutButtonState, 500);
});

document.addEventListener('cart:update', function () {
  setTimeout(updateCheckoutButtonState, 500);
});



// ============================= //
// UPDATE PRODUCT BUTTON TEXT OF ADD TO CART BUTTON
// ============================= //
function updateProductCartButtons() {
  fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var productQtyMap = {};

      cart.items.forEach(function (item) {
        var productId = String(item.product_id);

        if (!productQtyMap[productId]) {
          productQtyMap[productId] = 0;
        }

        productQtyMap[productId] += item.quantity;
      });

      $('.p-card').each(function () {
        var $card = $(this);

        var productId = '';

        productId = String($card.attr('data-product-id') || '').trim();

        var $modalBtn = $card.find('.open-order-modal[data-product-id]').first();
        var $normalForm = $card.find('product-form-component[data-product-id]').not('.modal-hidden-product-form').first();

        if ($modalBtn.length) {
          productId = String($modalBtn.attr('data-product-id') || '').trim();
        } else if ($normalForm.length) {
          productId = String($normalForm.attr('data-product-id') || '').trim();
        }

        if (!productId) return;

        var qty = productQtyMap[productId] || 0;

        var $visibleBtn = $card
          .find('.open-order-modal.p-order, product-form-component:not(.modal-hidden-product-form) button.p-order')
          .first();

        if (!$visibleBtn.length) return;

        var isWeekend =
            $card.closest('.product-grid').data('collection') === 'weekend';

        if (qty > 0) {
            $visibleBtn
                .text('Add')
                .addClass('in-cart');
        } else {
            $visibleBtn
                .text(isWeekend && isWeekendPreorderClosed() ? 'WhatsApp Order' : (isWeekend ? 'Pre Order' : 'Add'))
                .removeClass('in-cart');
        }
      });
    });
}

$(document).on('click', '.p-order, #modalBuyNow', function () {
  setTimeout(updateProductCartButtons, 1000);
  setTimeout(updateProductCartButtons, 2800);
});

$(document).on('click change input', 'cart-items-component, .cart-drawer__dialog, .cart-drawer__items, .cart-items__wrapper', function () {
  setTimeout(updateProductCartButtons, 800);
  setTimeout(updateProductCartButtons, 1800);
});

document.addEventListener('cart:refresh', updateProductCartButtons);
document.addEventListener('cart:update', updateProductCartButtons);

$(document).ready(function () {
    updateProductCartButtons();
});

$(window).on('load', function () {
    updateProductCartButtons();
});



// ============================= //
// CLOSE CART DRAWER IF CLICK ON "LOGIN TO CHECKOUT" BUTTON
// ============================= //
$(document).on('click', '.login-to-checkout', function (e) {
  e.preventDefault();

  var loginUrl = $(this).attr('href');

  $('.cart-drawer__close-button').trigger('click');

  setTimeout(function () {
    var lucentLoginButton = document.getElementById('lucent-login-button');

    if (lucentLoginButton) {
      lucentLoginButton.click();
      return;
    }

    if (loginUrl) {
      window.location.href = loginUrl;
    }
  }, 300);
});



// ============================= //
// MAKE FOOD ITEM DROPDOWN FIXED AT TOP WHEN SCROLL DOWN THE PAGE (FOR MOBILE)
// ============================= //
$(document).ready(function () {
  var $menu = $('#browseMenuBar');
  if (!$menu.length) return;

  var menuOffset = $menu.offset();
  if (!menuOffset) return;

  var stickyTop = menuOffset.top;

  $(window).on('scroll', function () {

    if ($(window).scrollTop() >= stickyTop) {
      $menu.addClass('browse-menu-sticky');
    } else {
      $menu.removeClass('browse-menu-sticky');
    }

  });
});



// ============================= //
// SCROLL TO FOOD COLLECTION (FOR MOBILE)
// ============================= //
$(document).on('change', '#collectionScrollDropdown', function () {
  var target = $(this).val();

  if (target && $(target).length) {

    $('html, body').animate({
      scrollTop: $(target).offset().top - 175
    }, 600);

    $(this).val('');
  }
});



// ============================= //
// WEEKLY MEAL MODAL
// ============================= //
/*
const banner = document.querySelector('.weekly-plan-banner');
if (banner) {
  banner.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      const openBtn = document.querySelector('.open-weekly-plan');
      if (openBtn) openBtn.click();
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('weeklyMealModal');
  const openBtn = document.querySelector('.open-weekly-plan');
  const closeBtn = document.querySelector('.weekly-close');

  const grossEl = document.getElementById('weekly-gross');
  const discountEl = document.getElementById('weekly-discount');
  const savingEl = document.getElementById('weekly-saving');
  const totalEl = document.getElementById('weekly-total');
  const addBtn = document.getElementById('add-weekly-plan');

  const header = document.querySelector('header');
  let wasScrolled = false;

  function openModal() {

      if (header) {
          wasScrolled = header.classList.contains('scrolled');
      }

      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('weekly-modal-open');

      if (header && wasScrolled) {
          header.classList.add('scrolled');
      }
  }

  function closeModal() {

      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('weekly-modal-open');

      if (header && wasScrolled) {
          header.classList.add('scrolled');
      }
  }

  if (openBtn) {
    openBtn.addEventListener('click', openModal);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeModal);
  }

  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });

  document.querySelectorAll('.meal-accordion-toggle').forEach(function(button) {
    button.addEventListener('click', function() {
      const row = button.closest('.meal-row');

      if (window.innerWidth <= 767) {
        row.classList.toggle('active');
      }
    });
  });

  function calculateTotal() {
    let gross = 0;

    document.querySelectorAll('.meal-row').forEach(function(row) {
      const price = Number(row.dataset.price || 0);

      row.querySelectorAll('.meal-qty').forEach(function(qty) {
        let quantity = Number(qty.value || 0);

        if (quantity < 0) {
          quantity = 0;
          qty.value = 0;
        }

        if (quantity > 0) {
          gross += price * quantity;
        }
      });
    });

    const discount = gross >= 3000 ? gross * 0.07 : 0;
    const total = gross - discount;

    grossEl.textContent = gross.toFixed(2);
    discountEl.textContent = gross >= 3000 ? '7%' : '0%';
    savingEl.textContent = discount.toFixed(2);
    totalEl.textContent = total.toFixed(2);

    if (gross > 0) {
      addBtn.disabled = false;
      addBtn.classList.remove('disabled');
    } else {
      addBtn.disabled = true;
      addBtn.classList.add('disabled');
    }
  }

  $(document).on('input change', '.meal-qty', function () {
    calculateTotal();
  });

  addBtn.addEventListener('click', function () {
    let items = [];

    document.querySelectorAll('.meal-qty').forEach(function(qty) {
      const quantity = Number(qty.value || 0);

      if (quantity > 0) {
        items.push({
          id: Number(qty.dataset.variantId),
          quantity: quantity,
          properties: {
            Day: qty.dataset.day,
            Meal: qty.dataset.meal,
            "Daily Meal Plan": "Yes"
          }
        });
      }
    });

    if (items.length === 0) {
      alert('Please enter quantity for at least one meal.');
      return;
    }

    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      if (cartHasRegularItems(cart)) {
        showMixedCartMessage();
        addBtn.disabled = false;
        addBtn.textContent = 'Add All items to Cart';
        throw 'mixed-cart';
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Cart add failed');
      }
      return response.json();
    })
    .then(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Weekly Order': 'Yes'
          }
        })
      });
    })
    .then(function () {
      return refreshCartAfterModalAdd();
    })
    .then(function() {
      addBtn.disabled = false;
      addBtn.textContent = 'Add All items to Cart';

      closeModal();

      var drawer =
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        var drawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

        if (drawerTrigger) {
          drawerTrigger.click();
        } else {
          window.location.href = '/cart';
        }
      }
    })
    .catch(function(error) {
      if (error === 'mixed-cart') {
        return;
      }

      alert('Something went wrong. Please try again.');
      addBtn.disabled = false;
      addBtn.textContent = 'Add all items to cart';
    });
  });

  calculateTotal();
});
*/



/* ====================================
WALLET MODAL: OPEN, CLOSE AND AMOUNT SELECTION
==================================== */
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('rrWalletModal');

  if (!modal) return;

  const closeButtons = modal.querySelectorAll('[data-wallet-close]');
  const amountButtons = modal.querySelectorAll('[data-wallet-amount]');
  const amountInput = modal.querySelector('#rrWalletAmount');
  const rechargeButton = modal.querySelector('#rrWalletRecharge');
  const error = modal.querySelector('#rrWalletError');

  function openWallet() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rr-wallet-open');
  }

  function closeWallet() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rr-wallet-open');
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.open-rr-wallet');

    if (!trigger) return;

    event.preventDefault();
    openWallet();
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeWallet);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeWallet();
    }
  });

  amountButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      const amount = this.dataset.walletAmount;

      amountButtons.forEach(function (item) {
        item.classList.remove('is-selected');
      });

      this.classList.add('is-selected');

      if (amountInput) {
        amountInput.value = amount;
      }

      if (error) {
        error.hidden = true;
      }
    });
  });

  if (amountInput) {
    amountInput.addEventListener('input', function () {
      amountButtons.forEach(function (button) {
        if (button.dataset.walletAmount === amountInput.value) {
          button.classList.add('is-selected');
        } else {
          button.classList.remove('is-selected');
        }
      });

      if (error) {
        error.hidden = true;
      }
    });
  }

  if (rechargeButton) {
    rechargeButton.addEventListener('click', function () {
      const amount = amountInput ? parseFloat(amountInput.value) : 0;

      if (!amount || amount <= 0) {
        if (error) {
          error.textContent = 'Please select or enter an amount.';
          error.hidden = false;
        }

        return;
      }

      console.log('RR Wallet recharge amount:', amount);

      if (error) {
        error.textContent = 'Wallet payment integration will be connected here.';
        error.hidden = false;
      }
    });
  }
});

(() => {
  if (customElements.get('rr-daily-meals')) return;
  const minimumPaise = 100000;
  const escape = (value) =>
    String(value ?? '').replace(
      /[&<>"']/g,
      (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
    );
  class RRWalletOrdering extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      const decode = (value) =>
        String(value).replace(
          /&(?:amp|quot|#39|lt|gt);/g,
          (entity) =>
            ({ '&amp;': '&', '&quot;': '"', '&#39;': "'", '&lt;': '<', '&gt;': '>' })[entity]
        );
      this.strings = Object.fromEntries(
        Object.entries(this.config.strings).map(([key, value]) => [key, decode(value)])
      );
      this.config.dailyStrings = Object.fromEntries(
        Object.entries(this.config.dailyStrings).map(([key, value]) => [key, decode(value)])
      );
      this.populateFilters();
      this.mode = 'daily';
      this.makeWeek();
      this.cart = [];
      this.balance = this.config.displayBalancePaise;
      this.verified = false;
      this.busy = false;
      this.amount = 1000;
      this.abort = new AbortController();
      this.addEventListener('click', (event) => this.handleClick(event), {
        signal: this.abort.signal
      });
      this.addEventListener('input', (event) => this.handleInput(event), {
        signal: this.abort.signal
      });
      this.querySelector('[role="tablist"]')?.addEventListener(
        'keydown',
        (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.mode =
            event.key === 'Home'
              ? 'daily'
              : event.key === 'End'
                ? 'regular'
                : this.mode === 'daily'
                  ? 'regular'
                  : 'daily';
          this.render();
          this.querySelector(`[data-mode="${this.mode}"]`).focus();
        },
        { signal: this.abort.signal }
      );
      this.render();
      this.refreshBalance();
    }

    populateFilters() {
      const products = this.config.products.filter((product) => product.mode === 'daily');
      this.querySelectorAll('[data-filter]').forEach((select) => {
        const key = select.dataset.filter;
        if (key === 'price') return;
        const selected = select.value;
        const existingLabels = new Map(
          Array.from(select.options, (option) => [option.value, option.textContent])
        );
        const allLabel = existingLabels.get('all') || 'All';
        const values = [...new Set(products.map((product) => product[key]))]
          .filter((value) => typeof value === 'string' && value && !value.startsWith('select-'))
          .sort((a, b) => a.localeCompare(b));
        select.replaceChildren(new Option(allLabel, 'all'));
        values.forEach((value) => {
          const label =
            existingLabels.get(value) ||
            value
              .split('-')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
          select.add(new Option(label, value));
        });
        select.value = values.includes(selected) ? selected : 'all';
      });
    }

    makeWeek() {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      const value = (type) => Number(parts.find((p) => p.type === type).value);
      const start = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      start.setUTCDate(start.getUTCDate() + 7 - start.getUTCDay());
      // During the last calendar week, the entire following month is bookable.
      // Start the selection at the first Sunday–Saturday row of that month.
      const thisSunday = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      thisSunday.setUTCDate(thisSunday.getUTCDate() - thisSunday.getUTCDay());
      const thisSaturday = new Date(thisSunday);
      thisSaturday.setUTCDate(thisSaturday.getUTCDate() + 6);
      const lastDay = new Date(Date.UTC(value('year'), value('month'), 0));
      if (thisSaturday >= lastDay) {
        const firstNextMonth = new Date(Date.UTC(value('year'), value('month'), 1));
        firstNextMonth.setUTCDate(firstNextMonth.getUTCDate() - firstNextMonth.getUTCDay());
        if (firstNextMonth > thisSunday) start.setTime(firstNextMonth.getTime());
      }
      this.week = Array.from({ length: 7 }, (_, i) => {
        const d = new Date(start);
        d.setUTCDate(d.getUTCDate() + i);
        return {
          date: d.toISOString().slice(0, 10),
          day: new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', weekday: 'long' }).format(d),
          label: new Intl.DateTimeFormat('en-IN', {
            timeZone: 'UTC',
            weekday: 'long',
            day: 'numeric',
            month: 'long'
          }).format(d)
        };
      });
    }
    dt(key) {
      return this.config.dailyStrings[key] || key;
    }

    dateUTC(iso) { return new Date(iso + 'T00:00:00Z'); }
    dateLabel(iso, opts = {day:'numeric',month:'short'}) { return new Intl.DateTimeFormat('en-IN',{timeZone:'UTC',...opts}).format(this.dateUTC(iso)); }
    selectWeek(iso) {
      if (this.week[0].date !== iso) this.cart = [];
      const start = this.dateUTC(iso);
      this.week = Array.from({length:7},(_,i)=>{const d=new Date(start);d.setUTCDate(d.getUTCDate()+i);return {date:d.toISOString().slice(0,10),day:new Intl.DateTimeFormat('en-IN',{timeZone:'UTC',weekday:'long'}).format(d),label:new Intl.DateTimeFormat('en-IN',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long'}).format(d)};});
      this.planTab = 'plan'; this.planWeekConfirmed = false; this.render();
    }
    renderWeek() {
      const nowParts = new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Kolkata',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const get = k => Number(nowParts.find(p=>p.type===k).value);
      const today = new Date(Date.UTC(get('year'),get('month')-1,get('day')));
      const currentSunday = new Date(today); currentSunday.setUTCDate(today.getUTCDate()-today.getUTCDay());
      const endOfCurrentMonth = new Date(Date.UTC(today.getUTCFullYear(),today.getUTCMonth()+1,0));
      const endOfCurrentWeek = new Date(currentSunday); endOfCurrentWeek.setUTCDate(currentSunday.getUTCDate()+6);
      // Show the current month until its final week; only then show next month.
      const displayMonthOffset = endOfCurrentWeek >= endOfCurrentMonth ? 1 : 0;
      const selected = this.week[0].date;
      const deliveryReady = Boolean(this.planWeekConfirmed && this.planLunch && this.planDinner);
      if (this.planTab === undefined) this.planTab = 'plan';
      const countDay = date => this.cart.filter(l=>l.mode==='daily'&&l.date===date).reduce((n,l)=>n+l.quantity,0);
      const tabs = [{key:'plan',title:'Plan week',sub:this.dateLabel(selected)+' – '+this.dateLabel(this.week[6].date)},...this.week.map((d,i)=>({key:String(i),title:d.day.slice(0,3),sub:this.dateLabel(d.date),count:countDay(d.date)}))];
      this.$('[data-plan-tabs]').innerHTML = tabs.map(t=>`<button type="button" class="rr-plan-tab" role="tab" data-action="plan-tab" data-plan-tab="${t.key}" aria-selected="${String(this.planTab===t.key)}" ${t.key!=='plan'&&!deliveryReady?'disabled aria-disabled="true"':''}>${escape(t.title)}${t.count?` <b>${t.count}</b>`:''}<small>${escape(t.sub)}</small></button>`).join('');
      const cal = this.$('[data-plan-calendar]');
      const filtersEl = this.$('.rr-plan-filters');
      const daysEl = this.$('[data-week-days]');
      const planning = this.planTab === 'plan';
      cal.hidden = !planning; filtersEl.hidden = planning; daysEl.hidden = planning;
      // Theme styles may override the native hidden attribute.
      cal.style.display = planning ? '' : 'none'; filtersEl.style.display = planning ? 'none' : '';daysEl.style.display = planning ? 'none' : '';
      if(planning){
        // Each row is a complete Sunday–Saturday week, including cross-month weeks.
        const monthBlocks=[];
        for(let offset=displayMonthOffset;offset<=displayMonthOffset;offset++){
          const monthFirst=new Date(Date.UTC(today.getUTCFullYear(),today.getUTCMonth()+offset,1));
          const monthLast=new Date(Date.UTC(today.getUTCFullYear(),today.getUTCMonth()+offset+1,0));
          const gridStart=new Date(monthFirst);gridStart.setUTCDate(gridStart.getUTCDate()-gridStart.getUTCDay());
          let weeks='';
          for(let start=new Date(gridStart);start<=monthLast;start.setUTCDate(start.getUTCDate()+7)){
            const iso=start.toISOString().slice(0,10),disabled=start<=currentSunday;
            const cells=Array.from({length:7},(_,i)=>{
              const d=new Date(start);d.setUTCDate(start.getUTCDate()+i);
              const otherMonth=d.getUTCMonth()!==monthFirst.getUTCMonth();
              return `<span class="${otherMonth?'rr-plan-out':''} ${d.getTime()===today.getTime()?'rr-plan-today':''}" title="${escape(this.dateLabel(d.toISOString().slice(0,10),{day:'numeric',month:'long',year:'numeric'}))}">${d.getUTCDate()}</span>`;
            }).join('');
            weeks+=`<button type="button" class="rr-plan-week" data-action="plan-week" data-week="${iso}" aria-pressed="${iso===selected}" ${disabled?'disabled':''}>${cells}</button>`;
          }
          monthBlocks.push(`<section class="rr-plan-month"><h3>${this.dateLabel(monthFirst.toISOString().slice(0,10),{month:'long',year:'numeric'})}</h3><div class="rr-plan-dow">${['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(x=>`<span>${x}</span>`).join('')}</div>${weeks}</section>`);
        }
        cal.innerHTML=`<div class="rr-plan-calendar"><p class="rr-plan-legend">Step 1: Select a delivery week. Select an upcoming week. During the final week of a month, the entire next month is available.</p><div class="rr-plan-months">${monthBlocks.join('')}</div><p class="rr-plan-selected">Selected week: <strong>${escape(this.dateLabel(selected,{day:'numeric',month:'short',year:'numeric'}))} – ${escape(this.dateLabel(this.week[6].date,{day:'numeric',month:'short',year:'numeric'}))}</strong></p><div class="rr-plan-slots"><label>Lunch delivery time<select data-plan-slot="lunch"><option value="">Select lunch time</option><option value="12:00 pm – 2:00 pm">12:00 pm – 2:00 pm</option><option value="2:00 pm – 4:00 pm">2:00 pm – 4:00 pm</option></select></label><label>Dinner delivery time<select data-plan-slot="dinner"><option value="">Select dinner time</option><option value="7:00 pm – 9:00 pm">7:00 pm – 9:00 pm</option><option value="9:00 pm – 11:00 pm">9:00 pm – 11:00 pm</option></select></label></div><p class="rr-plan-legend" data-plan-requirement>${deliveryReady?'Delivery week and times confirmed.':'Choose both delivery times before continuing.'}</p><button type="button" class="rr-plan-next" data-action="plan-confirm" ${this.planLunch&&this.planDinner?'':'disabled'}>Confirm Delivery & View Meals</button></div>`;
        cal.querySelector('[data-plan-slot="lunch"]').value=this.planLunch||'';
        cal.querySelector('[data-plan-slot="dinner"]').value=this.planDinner||'';

      } else {
        const day=this.week[Number(this.planTab)];
        const filters=Object.fromEntries([...this.querySelectorAll('[data-filter]')].map(f=>[f.dataset.filter,f.value]));
        const products=this.config.products.filter(p=>p.mode==='daily').filter(p=>Object.entries(filters).every(([k,v])=>v==='all'||(k==='price'?(()=>{const [min,max]=v.split('-').map(Number);return p.pricePaise>=min*100&&p.pricePaise<=max*100})():p[k]===v)));
        daysEl.innerHTML=`<h3 class="rr-plan-day-title">${escape(day.label)}</h3><p class="rr-plan-legend">Lunch ${escape(this.planLunch||'12:00 pm – 2:00 pm')} · Dinner ${escape(this.planDinner||'7:00 pm – 9:00 pm')}</p><div class="rr-plan-cards">${products.map(p=>{
          const price=Math.round(p.pricePaise*.75);
          const crown=`<svg viewBox="0 0 128 128" fill="currentColor" aria-hidden="true"><path d="M112 36a12 12 0 0 0-11.027 16.727L84 60 69.801 34.445A12 12 0 1 0 58.199 34.445L44 60l-16.973-7.273A12 12 0 1 0 18.695 59.672L28 100v8a8 8 0 0 0 8 8h56a8 8 0 0 0 8-8v-8l9.309-40.328A12 12 0 1 0 112 36ZM64 20a4 4 0 1 1 0 8 4 4 0 0 1 0-8ZM16 52a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm76 56H36v-8h56Zm1.633-16H34.367L27.34 61.563l13.508 5.789a8 8 0 0 0 10.144-3.469L64 40.477l13.008 23.406a8 8 0 0 0 10.144 3.469l13.508-5.789ZM112 52a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"/></svg>`;
          return `<article class="p-card rr-plan-card"><div class="p-card-inner"><div class="p-emoji">${p.image?`<img src="${escape(p.image)}" alt="${escape(p.title)}" loading="lazy">`:''}</div><div class="p-body"><div class="p-name-row"><div class="p-name">${escape(p.title)}</div></div>${p.bengaliName?`<div class="p-bengali">${escape(p.bengaliName)}</div>`:''}<div class="p-desc">${escape(p.description||'')}</div><div class="p-footer"><div class="p-ready-line"><span class="p-dish-type">${escape(p.dishType||p.diet||'Meal')}</span>${p.servingStatus?`<span class="p-serving-status">${escape(p.servingStatus)}</span>`:''}</div><div class="discount-strip"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 12 12 20 4 12V4h8l8 8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="8.5" cy="7.5" r="1.2" fill="currentColor"/></svg><span>RR Club Prime discount <b>25%</b></span></div><div class="p-price"><span class="p-special-price">${this.money(price)}</span><span class="p-price-meta"><s class="p-regular-price">${this.money(p.pricePaise)}</s></span></div><div class="p-footer-bottom">${['Lunch','Dinner'].map(meal=>{const key=[p.id,day.date,meal].join(':'),line=this.cart.find(l=>l.key===key);return `<div class="p-meal-row"><span class="p-meal-label">${meal}</span><div class="p-quantity stepper" style="width:100%;justify-content:space-between;"><button type="button" class="p-quantity-button" data-action="week-qty" data-id="${p.id}" data-date="${day.date}" data-meal="${meal}" data-delta="-1" data-week-focus="minus-${key}" ${line?'':'disabled'} aria-label="Decrease ${escape(meal)} ${escape(p.title)}">−</button><span class="p-quantity-input" aria-live="polite" style="line-height:38px;">${line?.quantity||0}</span><button type="button" class="p-quantity-button" data-action="week-qty" data-id="${p.id}" data-date="${day.date}" data-meal="${meal}" data-delta="1" data-week-focus="plus-${key}" ${p.available?'':'disabled'} aria-label="Increase ${escape(meal)} ${escape(p.title)}">+</button></div></div>`}).join('')}</div>${p.available?'':'<strong class="p-sold-out">Sold out</strong>'}</div></div></div></article>`;;
        }).join('')}</div>${products.length?'':'<p>No meals match these filters.</p>'}`;
      }
      this.$('[data-week-range]').textContent=this.week[0].label+' – '+this.week[6].label;
      const lines=this.cart.filter(l=>l.mode==='daily');
      const gross=lines.reduce((s,l)=>s+l.regularPricePaise*l.quantity,0);
      const total=lines.reduce((s,l)=>s+l.pricePaise*l.quantity,0);
      const calories=lines.reduce((s,l)=>s+(Number(l.cal)||0)*l.quantity,0);
      let box=this.$('[data-prime-estimate]');
      if(!box){box=document.createElement('div');box.dataset.primeEstimate='';box.className='rr-daily-estimate';this.$('[data-totals]').after(box)}
      box.innerHTML=`<div class="rr-daily-estimate__row"><span>Items Subtotal</span><strong>${this.money(total)}</strong></div><div class="rr-daily-estimate__row rr-daily-estimate__savings"><span>Estimated 25% savings</span><strong>${this.money(gross-total)}</strong></div><div class="rr-daily-estimate__row"><span>Total Calories</span><strong>${calories.toLocaleString()} kcal</strong></div>`;
    }

    weekQty(button) {
      const { id, date, meal } = button.dataset;
      const delta = Number(button.dataset.delta);
      const product = this.config.products.find((p) => String(p.id) === id && p.mode === 'daily');
      const day = this.week.find((d) => d.date === date);
      if (!product || !day) return;
      if (delta > 0 && (!product.available || this.cart.some((l) => l.mode === 'regular'))) {
        this.message(this.dt('regular_blocked'));
        return;
      }
      if (delta > 0 && this.verified && this.balance < minimumPaise) {
        this.rechargeDialog();
        return;
      }
      const key = [id, date, meal].join(':');
      const line = this.cart.find((l) => l.key === key);
      if (line) line.quantity = Math.max(0, Math.min(20, line.quantity + delta));
      else if (delta > 0)
        this.cart.push({
          ...this.cartProduct(product),
          key,
          date,
          day: day.day,
          meal,
          quantity: 1
        });
      this.cart = this.cart.filter((l) => l.quantity > 0);
      const focusKey=button.dataset.weekFocus;
      this.render();
      if(focusKey){const next=[...this.querySelectorAll('[data-week-focus]')].find(el=>el.dataset.weekFocus===focusKey);next?.focus({preventScroll:true});}
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.initialized = false;
    }
    $(selector) {
      return this.querySelector(selector);
    }
    t(key, values = {}) {
      return Object.entries(values).reduce(
        (s, [name, value]) => s.replaceAll(`{${name}}`, value),
        this.strings[key] || key
      );
    }
    money(paise) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: this.config.currency || 'INR'
      }).format(paise / 100);
    }

    cartProduct(product) {
      const regularPricePaise = product.pricePaise;
      return {
        ...product,
        regularPricePaise,
        pricePaise:
          product.mode === 'daily' ? Math.round(regularPricePaise * 0.75) : regularPricePaise
      };
    }
    get amountPaise() {
      return this.cart.reduce((sum, line) => sum + line.pricePaise * line.quantity, 0);
    }
    get proxyRoot() {
      const root = (this.config.proxyRoot || '').replace(/\/+$/, '');
      return /^\/apps\/[a-zA-Z0-9_/-]+$/.test(root) ? root : null;
    }

    async request(path, body) {
      if (!this.proxyRoot) throw new Error(this.t('connection_body'));
      const response = await fetch(this.proxyRoot + path, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          ...(body ? { 'Content-Type': 'application/json' } : {})
        },
        body: body ? JSON.stringify(body) : undefined,
        signal: this.abort.signal
      });
      const data = await response.json().catch(() => null);
      if (
        !response.ok ||
        !data ||
        (path === '/balance' ? data.balanceVerified !== true : data.ok !== true)
      )
        throw new Error(
          this.t(
            {
              AUTH_REQUIRED: 'session_required',
              MINIMUM_BALANCE: 'below_minimum',
              INSUFFICIENT_FUNDS: 'insufficient',
              MIXED_CART: 'mixed_body',
              PAYMENT_NOT_READY: 'connection_body'
            }[data?.code] || 'backend_error'
          )
        );
      return data;
    }
    async refreshBalance() {
      if (!this.proxyRoot || !this.config.customerSignedIn) return;
      try {
        const data = await this.request('/balance');
        if (
          !Number.isSafeInteger(data.balancePaise) ||
          data.balancePaise < 0 ||
          data.currency !== 'INR' ||
          data.balanceVerified !== true
        )
          throw new Error(this.t('connection_body'));
        this.balance = data.balancePaise;
        this.verified = true;
        this.customerRechargeEnabled = data.customerRechargeEnabled === true;
        this.customerRechargeReady = data.customerRechargeReady === true;
      } catch (error) {
        this.verified = false;
        this.balance = 0;
        this.message(error.message);
      }
      this.render();
    }

    status() {
      if (!this.cart.length) return { allowed: false, message: this.t('empty_cart') };
      if (!this.config.customerSignedIn) return { allowed: false, message: this.t('login_needed') };
      if (!this.verified || this.config.previewCollections)
        return { allowed: false, message: this.t('connection_pending') };
      if (this.cart[0].mode === 'daily') {
        if (this.balance < minimumPaise)
          return {
            allowed: false,
            message: this.t('minimum_needed', { amount: this.money(minimumPaise - this.balance) })
          };
        if (this.balance < this.amountPaise)
          return {
            allowed: false,
            message: this.t('amount_needed', {
              amount: this.money(this.amountPaise - this.balance)
            })
          };
      }
      return { allowed: !this.busy, message: this.t('checkout_allowed') };
    }

    render() {
      const focusKey = document.activeElement?.dataset.focusKey;
      this.renderWeek();
      this.$('[data-balance]').textContent = this.money(this.balance);
      this.$('[data-eligibility]').textContent = !this.config.customerSignedIn
        ? this.t('login_needed')
        : !this.verified
          ? this.t('connection_pending')
          : this.balance < minimumPaise
            ? this.t('minimum_needed', { amount: this.money(minimumPaise - this.balance) })
            : this.t('eligible');
      const walletProgress = this.$('[data-wallet-progress]');
      if (walletProgress) {
        const balance = Math.max(0, Number(this.balance) || 0);
        walletProgress.value = Math.min(minimumPaise, balance);
        this.$('[data-wallet-gap]').textContent =
          balance < minimumPaise
            ? this.money(minimumPaise - balance) + ' more to unlock'
            : 'Minimum balance reached';
        this.$('[data-wallet-badge]').textContent = !this.config.customerSignedIn
          ? 'Sign in to view wallet'
          : !this.verified
            ? 'Wallet connection pending'
            : balance < minimumPaise
              ? 'Below ₹1,000 minimum'
              : 'Wallet balance verified';
      }
      this.querySelectorAll('[data-action="tab"]').forEach((button) => {
        const active = button.dataset.mode === this.mode;
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      this.$('[data-cart-count]').textContent = this.cart.reduce(
        (sum, line) => sum + line.quantity,
        0
      );
      this.$('[data-cart]').innerHTML = this.cart.length
        ? this.cart.every((line) => line.mode === 'daily' && line.date)
          ? this.week
              .map((day) => {
                const lines = this.cart.filter(
                  (line) => line.mode === 'daily' && line.date === day.date
                );
                const quantity = lines.reduce(
                  (total, line) => total + line.quantity,
                  0
                );
                const amount = lines.reduce(
                  (total, line) => total + line.pricePaise * line.quantity,
                  0
                );
                if (!quantity) return '';
                const dayCalories = lines.reduce((sum, line) => sum + (Number(line.cal) || 0) * line.quantity, 0);
                return `<div class="rr-ordering__cart-item"><div><strong>${escape(day.day)}</strong><small>${quantity} ${quantity === 1 ? 'item' : 'items'}</small><small class="rr-ordering__day-calories">${dayCalories.toLocaleString()} kcal total</small></div><span>${this.money(amount)}</span></div>`;
              })
              .join('')
          : this.cart
            .map(
              (line) =>
                `<div class="rr-ordering__cart-item"><div><strong>${escape(line.title)}</strong>${line.date ? `<small>${escape(line.date)} · ${escape(line.meal)}</small>` : ''}<div class="rr-ordering__quantity"><button type="button" data-action="qty" data-id="${line.id}" data-key="${escape(line.key || String(line.id))}" data-delta="-1" data-focus-key="minus-${escape(line.key || String(line.id))}" aria-label="${escape(this.t('reduce'))} ${escape(line.title)}">−</button><span>${line.quantity}</span><button type="button" data-action="qty" data-id="${line.id}" data-key="${escape(line.key || String(line.id))}" data-delta="1" data-focus-key="plus-${escape(line.key || String(line.id))}" aria-label="${escape(this.t('increase'))} ${escape(line.title)}">+</button></div></div><span>${this.money(line.pricePaise * line.quantity)}</span></div>`
            )
            .join('')
        : `<p class="rr-ordering__empty">${escape(this.t('empty_cart'))}</p>`;
      this.$('[data-totals]').innerHTML =
        `<span>Items Subtotal</span><span>${this.money(this.amountPaise)}</span>`;
      const hasItems = this.cart.some((line) => line.quantity > 0);
      this.$('[data-checkout-state]').textContent = hasItems
        ? 'Selected meals will be added with their delivery dates. Checkout calculates the final prices and discounts.'
        : this.t('empty_cart');
      this.$('[data-checkout-state]').className = 'rr-ordering__notice';
      const checkout = this.$('[data-action="checkout"]');
      const walletCheck = this.selectionWalletCheck();
      if (hasItems && !walletCheck.allowed) {
        this.$('[data-checkout-state]').textContent = walletCheck.message;
        this.$('[data-checkout-state]').className = 'rr-ordering__notice blocked';
      }
      checkout.disabled = !hasItems || this.busy || !walletCheck.allowed;
      checkout.textContent = this.busy ? 'Adding…' : 'Add All Items to Cart';
      if (focusKey)
        this.querySelector(`[data-focus-key="${focusKey}"]`)?.focus({ preventScroll: true });
    }

    add(id, mode) {
      const product = this.config.products.find(
        (item) => String(item.id) === String(id) && item.mode === mode
      );
      if (!product || !product.available) return;
      if (this.cart.length && this.cart[0].mode !== mode) {
        this.pendingProduct = product;
        this.dialog(
          this.t('mixed_title'),
          `<p>${escape(this.t('mixed_body'))}</p><div class="rr-ordering__dialog-buttons"><button type="button" class="rr-ordering__text-button" data-action="close">${escape(this.t('keep_cart'))}</button><button type="button" class="rr-ordering__button" data-action="replace">${escape(this.t('replace_cart'))}</button></div>`
        );
        return;
      }
      if (mode === 'daily' && this.verified && this.balance < minimumPaise) {
        this.rechargeDialog();
        return;
      }
      const existing = this.cart.find((line) => line.id === product.id && !line.date);
      if (existing) existing.quantity = Math.min(20, existing.quantity + 1);
      else this.cart.push({ ...this.cartProduct(product), key: String(product.id), quantity: 1 });
      this.render();
      this.message(this.t('item_added'));
    }

    dialog(title, body) {
      this.$('[data-dialog]').classList.remove('rr-recharge-dialog');
      this.$('[data-dialog-title]').textContent = title;
      this.$('[data-dialog-body]').innerHTML = body;
      if (!this.$('[data-dialog]').open) this.$('[data-dialog]').showModal();
      this.$('[data-dialog-body] button')?.focus({ preventScroll: true });
    }
    close() {
      this.$('[data-dialog]').close();
    }

    rechargeMoney(paise) {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: this.config.currency || 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(paise / 100);
    }
    async customerRequest(action, fields = {}) {
      const response = await fetch(this.proxyRoot + '/customer-recharge', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        body: new URLSearchParams({
          action,
          ...(action === 'authorize'
            ? {}
            : {
                token: this.customerToken || '',
                request_key: this.customerState?.key || ''
              }),
          ...fields
        }),
        signal: this.abort.signal
      });
      const data = await response.json().catch(() => null);
      if (!response.ok || !data || data.error)
        throw Error(
          data?.error ||
            'Wallet recharge is unavailable. Reopen Add money to resume any payment already made.'
        );
      return data;
    }
    customerAmountValid(paise) {
      return Number.isSafeInteger(paise) && paise >= 100 && paise <= 5000000;
    }
    saveCustomerState() {
      try {
        if (this.customerState)
          sessionStorage.setItem(this.customerStorageKey, JSON.stringify(this.customerState));
        else sessionStorage.removeItem(this.customerStorageKey);
      } catch {}
    }

    async loadRazorpay() {
      if (typeof window.Razorpay === 'function') return;
      if (!window.rrRazorpayLoader) {
        window.rrRazorpayLoader = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://checkout.razorpay.com/v1/checkout.js';
          script.onload = resolve;
          script.onerror = () => {
            script.remove();
            reject(Error('Payment window could not load. Please try again.'));
          };
          document.head.append(script);
        }).catch((error) => {
          window.rrRazorpayLoader = null;
          throw error;
        });
      }
      await window.rrRazorpayLoader;
      if (typeof window.Razorpay !== 'function') throw Error('Payment window is unavailable.');
    }

    async rechargeDialog() {
      if (this.rechargeLoading || this.busy) return;
      if (!this.config.customerSignedIn) {
        this.dialog(
          'Add money to your wallet',
          `<p>Sign in to add money to your wallet.</p><a class="rr-ordering__button" href="${escape(this.config.loginUrl)}">${escape(this.t('sign_in'))}</a>`
        );
        return;
      }
      if (!this.proxyRoot) {
        this.dialog(
          'Add money to your wallet',
          '<p>Wallet recharge is temporarily unavailable.</p>'
        );
        return;
      }
      this.rechargeLoading = true;
      this.dialog('Add money to your wallet', '<p>Loading your wallet…</p>');
      try {
        await this.refreshBalance();
        if (!this.verified || !this.customerRechargeEnabled)
          throw Error('Wallet recharge is temporarily unavailable.');
        const data = await this.customerRequest('authorize');
        if (
          data.customerRecharge !== true ||
          data.testOnly !== false ||
          typeof data.token !== 'string' ||
          !/^[a-f0-9]{64}$/.test(data.scopeKey || '') ||
          data.minPaise !== 100 ||
          data.maxPaise !== 5000000
        )
          throw Error('Unexpected wallet response.');
        this.customerToken = data.token;
        this.customerStorageKey = 'rr_daily_recharge_customer_' + data.scopeKey;
        try {
          this.customerState = JSON.parse(
            sessionStorage.getItem(this.customerStorageKey) || 'null'
          );
        } catch {
          this.customerState = null;
        }
        if (
          !this.customerState ||
          !/^[a-f0-9]{64}$/.test(this.customerState.key || '') ||
          !this.customerAmountValid(this.customerState.amountPaise)
        )
          this.customerState = null;
        if (data.pending) {
          if (
            !/^[a-f0-9]{64}$/.test(data.pending.request_key || '') ||
            !this.customerAmountValid(data.pending.amountPaise)
          )
            throw Error('Previous recharge requires review. Do not pay again.');
          const same = this.customerState?.key === data.pending.request_key;
          this.customerState = {
            key: data.pending.request_key,
            amountPaise: data.pending.amountPaise,
            response: same ? this.customerState.response : null
          };
        }
        this.saveCustomerState();
        this.amount = this.customerState ? this.customerState.amountPaise / 100 : 1000;
        this.customerNotice = '';
        this.customerReview = false;
        this.customerPaymentPending = false;
        if (this.customerState) {
          const state = await this.customerRequest(
            this.customerState.response ? 'verify' : 'resume',
            this.customerState.response || {}
          );
          if (state.credited === true) {
            this.customerState = null;
            this.saveCustomerState();
            await this.refreshBalance();
            this.customerNotice = state.message || 'Your wallet recharge is complete.';
          } else {
            this.customerReview = state.reviewRequired === true;
            this.customerPaymentPending = state.paymentPending === true;
            const paymentNeedsRecovery = state.paid === true || this.customerReview ||
              this.customerPaymentPending || Boolean(this.customerState.response);
            if (paymentNeedsRecovery) {
              this.customerNotice = state.message ||
                'Payment is processing. Check its status before making another payment.';
            } else {
              // The server checked the previous order and found no processing payment.
              // Release its UI state; the backend retains the record for late webhooks.
              this.customerState = null;
              this.saveCustomerState();
              this.amount = 1000;
              this.customerNotice = '';
            }
          }
        }
        this.renderCustomerRecharge();
      } catch (error) {
        this.dialog(
          'Add money to your wallet',
          `<p role="alert">${escape(error.message)}</p><p>If you already paid, reopen Add money to resume verification. Do not pay again.</p>`
        );
      } finally {
        this.rechargeLoading = false;
      }
    }

    renderCustomerRecharge() {
      const locked = Boolean(this.customerState);
      const body = `<div class="rr-recharge__balance"><span>Available wallet balance</span><strong>${escape(this.rechargeMoney(this.balance))}</strong></div>
        ${this.customerNotice ? `<p role="status">${escape(this.customerNotice)}</p>` : ''}
        <div class="rr-ordering__recharge-options" style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin:18px 0">
        ${[1000, 2000, 5000].map((amount) => `<button type="button" data-action="customer-amount" data-amount="${amount}" ${locked ? 'disabled' : ''} aria-pressed="${amount === this.amount}" class="${amount === this.amount ? 'active' : ''}">${escape(this.rechargeMoney(amount * 100))}</button>`).join('')}</div>
        <label class="rr-recharge__label">Or enter an amount<input data-customer-custom type="number" min="1" max="50000" step="0.01" inputmode="decimal" value="${this.amount}" ${locked ? 'disabled' : ''} style="display:block;width:100%;padding:12px;margin:12px 0"></label>
        <p>Choose ₹1 to ₹50,000. You need at least ₹1,000 in your wallet to order Daily Meals.</p>
        <p class="rr-ordering__error" data-customer-error role="alert"></p>
        <button type="button" class="rr-recharge__continue" data-action="customer-pay"></button>
        <p class="rr-recharge__notice">Wallet balance updates after payment verification. If confirmation is delayed, resume this recharge before making another payment.</p>`;
      this.dialog('Add money to your wallet', body);
      this.$('[data-dialog]').classList.add('rr-recharge-dialog');
      this.updateCustomerAmount();
    }
    updateCustomerAmount() {
      const button = this.$('[data-action="customer-pay"]');
      if (!button) return;
      const paise = Math.round(this.amount * 100);
      const valid =
        Number.isFinite(this.amount) &&
        this.customerAmountValid(paise) &&
        Math.abs(this.amount * 100 - paise) < 0.00001;
      button.disabled =
        this.busy || !valid || !this.customerToken || !this.verified || this.customerReview;
      button.textContent = this.busy
        ? 'Processing…'
        : this.customerReview
          ? 'Payment received — under review'
          : this.customerPaymentPending || this.customerState?.response
            ? 'Check payment status'
            : this.customerState
              ? 'Resume ' + this.rechargeMoney(this.customerState.amountPaise)
              : 'Pay ' + this.rechargeMoney(paise);
      const error = this.$('[data-customer-error]');
      if (error && !this.busy)
        error.textContent = valid
          ? ''
          : 'Enter an amount from ₹1 to ₹50,000 with at most two decimal places.';
    }

    async handleCustomerResult(data) {
      if (data.credited === true) {
        if (data.paid !== true) throw Error('Unexpected credit response.');
        this.customerState = null;
        this.saveCustomerState();
        this.close();
        await this.refreshBalance();
        this.message(data.message || 'Money added to your wallet.');
        return true;
      }
      if (data.reviewRequired === true || data.paymentPending === true || data.paid === true) {
        this.customerReview = data.reviewRequired === true;
        this.customerPaymentPending = data.paymentPending === true;
        this.customerNotice = data.message || 'Payment is processing. Do not pay again.';
        this.renderCustomerRecharge();
        return true;
      }
      return false;
    }
    async finishCustomerPayment() {
      const data = await this.customerRequest(
        this.customerState.response ? 'verify' : 'resume',
        this.customerState.response || {}
      );
      if (!(await this.handleCustomerResult(data)))
        throw Error('Payment is not yet confirmed. Resume this recharge; do not pay again.');
    }

    async payCustomerRecharge() {
      const paise = Math.round(this.amount * 100);
      if (
        this.busy ||
        !this.customerToken ||
        !this.verified ||
        this.customerReview ||
        !this.customerAmountValid(paise) ||
        Math.abs(this.amount * 100 - paise) >= 0.00001
      )
        return;
      this.busy = true;
      this.updateCustomerAmount();
      try {
        if (this.customerState?.response) {
          await this.finishCustomerPayment();
          return;
        }
        if (this.customerPaymentPending) {
          const state = await this.customerRequest('resume');
          if (!(await this.handleCustomerResult(state))) {
            this.customerPaymentPending = false;
            this.customerNotice = 'No captured payment found. You can resume this same recharge.';
            this.renderCustomerRecharge();
          }
          return;
        }
        await this.loadRazorpay();
        if (!this.customerState) {
          this.customerState = {
            key: Array.from(crypto.getRandomValues(new Uint8Array(32)), (x) =>
              x.toString(16).padStart(2, '0')
            ).join(''),
            amountPaise: paise,
            response: null
          };
          this.saveCustomerState();
        }
        const requestedKey = this.customerState.key;
        const data = await this.customerRequest('create', {
          amount: (this.customerState.amountPaise / 100).toFixed(2)
        });
        if (
          !/^[a-f0-9]{64}$/.test(data.request_key || '') ||
          !this.customerAmountValid(data.amountPaise)
        )
          throw Error('Invalid saved recharge. Do not pay again.');
        const changed =
          data.request_key !== requestedKey || data.amountPaise !== this.customerState.amountPaise;
        this.customerState.key = data.request_key;
        this.customerState.amountPaise = data.amountPaise;
        this.amount = data.amountPaise / 100;
        this.saveCustomerState();
        if (await this.handleCustomerResult(data)) return;
        const state = await this.customerRequest('resume');
        if (await this.handleCustomerResult(state)) return;
        if (changed) {
          this.customerNotice =
            'An earlier recharge for ' +
            this.rechargeMoney(data.amountPaise) +
            ' was recovered. Review its amount, then resume it.';
          this.renderCustomerRecharge();
          return;
        }
        if (
          !/^rzp_live_[A-Za-z0-9]+$/.test(data.key || '') ||
          !/^order_[A-Za-z0-9]+$/.test(data.order_id || '') ||
          data.amount !== this.customerState.amountPaise
        )
          throw Error('Unexpected payment amount. Payment blocked.');
        this.close();
        await new Promise((resolve, reject) => {
          let responded = false;
          const checkout = new window.Razorpay({
            key: data.key,
            order_id: data.order_id,
            amount: data.amount,
            currency: 'INR',
            name: 'Ritur Rannaghar',
            description: 'Wallet recharge',
            theme: { color: '#99251f' },
            handler: (response) => {
              responded = true;
              this.customerState.response = {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature
              };
              this.saveCustomerState();
              this.finishCustomerPayment().then(resolve, reject);
            },
            modal: {
              ondismiss: () => {
                if (!responded) resolve();
              }
            }
          });
          checkout.on('payment.failed', () =>
            this.message('Payment failed. Reopen Add money to resume the same recharge.')
          );
          checkout.open();
        });
      } catch (error) {
        this.customerNotice = error.message;
        this.renderCustomerRecharge();
      } finally {
        this.busy = false;
        this.updateCustomerAmount();
      }
    }

    redirect(url) {
      const target = new URL(url, location.origin);
      if (target.protocol !== 'https:' || target.origin !== location.origin)
        throw new Error(this.t('backend_error'));
      location.assign(target.href);
    }

    async submit(kind) {
      if (kind === 'recharge') return this.payCustomerRecharge();
      if (this.busy || !this.verified || this.config.previewCollections) return;
      if (kind === 'checkout' && !this.status().allowed) return;
      if (
        kind === 'recharge' &&
        (!Number.isSafeInteger(this.amount) || this.amount < 1 || this.amount > 100000)
      )
        return;
      this.busy = true;
      this.render();
      if (kind === 'recharge') this.updateAmount();
      try {
        const signature =
          kind === 'recharge'
            ? String(this.amount)
            : JSON.stringify(
                this.cart.map((line) => ({
                  id: line.id,
                  mode: line.mode,
                  quantity: line.quantity,
                  date: line.date,
                  meal: line.meal
                }))
              );
        const attemptField = kind === 'recharge' ? 'rechargeAttempt' : 'checkoutAttempt';
        if (this[attemptField]?.signature !== signature)
          this[attemptField] = { signature, key: crypto.randomUUID() };
        const payload =
          kind === 'recharge'
            ? {
                amountPaise: this.amount * 100,
                currency: 'INR',
                idempotencyKey: this[attemptField].key
              }
            : {
                mode: this.cart[0].mode,
                items: this.cart.map((line) => ({
                  variantId: String(line.id),
                  quantity: line.quantity,
                  ...(line.date
                    ? {
                        properties: {
                          'Delivery date': line.date,
                          Day: line.day,
                          Meal: line.meal,
                          'Daily Meal Plan': 'Yes'
                        }
                      }
                    : {})
                })),
                currency: 'INR',
                idempotencyKey: this[attemptField].key
              };
        const data = await this.request(kind === 'recharge' ? '/recharges' : '/checkout', payload);
        if (!data.redirectUrl) throw new Error(this.t('payment_pending'));
        this.redirect(data.redirectUrl);
      } catch (error) {
        this.message(error.message);
      } finally {
        this.busy = false;
        this.render();
        if (kind === 'recharge' && this.$('[data-amount-error]')) this.updateAmount();
      }
    }

    async refreshAndOpenCartDrawer(root) {
      let drawer =
        document.querySelector('cart-drawer-component') || document.querySelector('cart-drawer');
      if (!drawer) throw new Error('Cart drawer unavailable.');
      const items = drawer.querySelector('cart-items-component[data-section-id]');
      const sectionWrapper = drawer.closest('[id^="shopify-section-"]');
      const sectionId =
        items?.getAttribute('data-section-id') ||
        sectionWrapper?.id.replace(/^shopify-section-/, '');
      if (!sectionId) throw new Error('Cart drawer section unavailable.');
      const response = await fetch(root + '?sections=' + encodeURIComponent(sectionId), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart drawer refresh failed.');
      const sections = await response.json();
      if (!sections[sectionId]) throw new Error('Cart drawer markup unavailable.');
      const parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      const freshDrawer =
        parsed.querySelector('cart-drawer-component') || parsed.querySelector('cart-drawer');
      if (!freshDrawer) throw new Error('Cart drawer markup unavailable.');
      const dialog =
        drawer.querySelector('dialog.cart-drawer__dialog') || drawer.querySelector('dialog');
      const freshDialog =
        freshDrawer.querySelector('dialog.cart-drawer__dialog') ||
        freshDrawer.querySelector('dialog');
      if (!dialog || !freshDialog) throw new Error('Cart drawer dialog unavailable.');
      dialog.innerHTML = freshDialog.innerHTML;
      dialog.className = freshDialog.className;
      const labelledBy = freshDialog.getAttribute('aria-labelledby');
      if (labelledBy) dialog.setAttribute('aria-labelledby', labelledBy);
      await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      const freshBubble = parsed.querySelector('.cart-bubble');
      const currentBubble = document.querySelector('.cart-bubble');
      if (freshBubble && currentBubble) {
        currentBubble.innerHTML = freshBubble.innerHTML;
        currentBubble.className = freshBubble.className;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:update'));
      if (dialog.open) return;
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (!trigger) throw new Error('Cart drawer trigger unavailable.');
        trigger.click();
      }
    }

    selectionWalletCheck() {
      const dailyTotal = this.cart
        .filter((line) => line.mode === 'daily')
        .reduce((sum, line) => sum + line.pricePaise * line.quantity, 0);
      const balance = Math.max(0, Number(this.balance) || 0);
      if (dailyTotal > 0 && !this.config.customerSignedIn)
        return { allowed: false, message: 'Sign in to your account to select daily meals.' };
      if (dailyTotal > 0 && !this.verified)
        return {
          allowed: false,
          message: 'Your wallet balance must be verified before adding daily meals.'
        };
      if (dailyTotal > 0 && balance < minimumPaise)
        return {
          allowed: false,
          message: 'Keep at least ₹1,000 in your wallet before ordering daily meals.'
        };
      if (dailyTotal <= balance) return { allowed: true, message: '' };
      return {
        allowed: false,
        message: `Your wallet balance is insufficient for the selected meals. Add ${this.money(dailyTotal - balance)} to your wallet to add all items to cart. Selected total: ${this.money(dailyTotal)}. Wallet balance: ${this.money(balance)}.`
      };
    }

    async addAllToShopifyCart() {
      if (this.busy || !this.cart.length) return;
      const walletCheck = this.selectionWalletCheck();
      if (!walletCheck.allowed) {
        this.message(walletCheck.message);
        this.render();
        return;
      }
      this.busy = true;
      this.render();
      const root = window.Shopify?.routes?.root || '/';
      let attemptedAdd = false;
      try {
        if (this.proxyRoot && this.config.customerSignedIn) {
          await this.refreshBalance();
          const updatedWalletCheck = this.selectionWalletCheck();
          if (!updatedWalletCheck.allowed) throw new Error(updatedWalletCheck.message);
        }
        const currentResponse = await fetch(root + 'cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!currentResponse.ok)
          throw new Error('Unable to check the current cart. Please try again.');
        const currentCart = await currentResponse.json();
        const dailyProductIds = new Set(
          this.config.products
            .filter((product) => product.mode === 'daily')
            .map((product) => String(product.productId))
        );
        const addingDaily = this.cart.every((line) => line.mode === 'daily');
        const incompatible = currentCart.items.some((item) =>
          addingDaily
            ? !dailyProductIds.has(String(item.product_id))
            : dailyProductIds.has(String(item.product_id))
        );
        if (addingDaily && currentCart.total_price + this.amountPaise > this.balance)
          throw new Error(
            'Your wallet must cover both the meals already in your cart and this selection.'
          );
        if (incompatible)
          throw new Error(
            'Daily meals and other products cannot be combined. Please remove the other items from your cart first.'
          );
        const items = this.cart
          .filter((line) => line.quantity > 0)
          .map((line) => ({
            //id: String(line.id),
            id: Number(line.id),
            quantity: line.quantity,
            properties: line.date
              ? {
                  'Delivery date': line.date,
                  Day: line.day,
                  Meal: line.meal,
                  'Daily Meal Plan': 'Yes'
                }
              : {}
          }));
        attemptedAdd = true;
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items)) {
          throw new Error(
            result.description || result.message || 'Unable to add the selected meals.'
          );
        }
        this.cart = [];
        this.render();
        try {
          await this.refreshAndOpenCartDrawer(root);
          this.message('All selected meals have been added to your cart.');
        } catch (drawerError) {
          this.message(
            'Your meals were added to the cart, but the drawer could not refresh. Open the header cart to view them.'
          );
        }
      } catch (error) {
        this.message(
          error.message +
            (attemptedAdd
              ? ' Check your cart before trying again; some items may already have been added.'
              : '')
        );
      } finally {
        this.busy = false;
        this.render();
      }
    }

    message(text) {
      const target = this.$('[data-message]');
      target.textContent = text;
      target.setAttribute('role', 'status');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    handleInput(event) {
      if (event.target.hasAttribute('data-customer-custom')) {
        if (this.customerState) return;
        this.amount = Number(event.target.value);
        this.querySelectorAll('[data-action="customer-amount"]').forEach((button) =>
          button.classList.remove('active')
        );
        this.updateCustomerAmount();
        return;
      }
      if (event.target.hasAttribute('data-plan-slot')) {
        this[event.target.dataset.planSlot === 'lunch' ? 'planLunch' : 'planDinner'] = event.target.value;
        this.planWeekConfirmed = false;
        const next=this.$('[data-action="plan-confirm"]'); if(next)next.disabled=!(this.planLunch&&this.planDinner);
        const note=this.$('[data-plan-requirement]');if(note)note.textContent=this.planLunch&&this.planDinner?'Ready to confirm delivery.':'Choose both delivery times before continuing.';
        return;
      }
      if (event.target.hasAttribute('data-filter')) {
        this.renderWeek();
        return;
      }
      if (event.target.hasAttribute('data-custom-amount')) {
        this.amount = Number(event.target.value);
        this.querySelectorAll('[data-action="amount"]').forEach((button) =>
          button.classList.remove('active')
        );
        this.updateAmount();
      }
    }

    handleClick(event) {
      const button = event.target.closest('[data-action]');
      if (!button || button.disabled || this.busy) return;
      const { action, id, mode } = button.dataset;
      if (action === 'plan-tab') { if(button.dataset.planTab!=='plan'&&!(this.planWeekConfirmed&&this.planLunch&&this.planDinner)){this.message('Select a delivery week and both delivery times first.');return;} this.planTab=button.dataset.planTab; this.renderWeek(); return; }
      if (action === 'plan-confirm') { if(!(this.planLunch&&this.planDinner)){this.message('Please select lunch and dinner delivery times.');return;}this.planWeekConfirmed=true;this.planTab='0';this.renderWeek();return; }
      if (action === 'plan-week') { if(button.disabled)return; this.selectWeek(button.dataset.week); return; }
      if (action === 'week-qty') {
        this.weekQty(button);
        return;
      }
      if (action === 'tab') {
        this.mode = mode;
        this.render();
      } else if (action === 'add') this.add(id, mode);
      else if (action === 'qty') {
        const line = this.cart.find(
          (item) => String(item.key || item.id) === (button.dataset.key || id)
        );
        if (line) {
          const delta = Number(button.dataset.delta);
          if (delta > 0 && line.mode === 'daily' && this.verified && this.balance < minimumPaise) {
            this.rechargeDialog();
            return;
          }
          line.quantity = Math.min(20, line.quantity + delta);
          this.cart = this.cart.filter((item) => item.quantity > 0);
          this.render();
        }
      } else if (action === 'clear') {
        this.cart = [];
        this.render();
        this.message(this.t('cart_cleared'));
      } else if (action === 'replace') {
        const product = this.pendingProduct;
        this.cart = [];
        this.close();
        this.add(product.id, product.mode);
      } else if (action === 'close') this.close();
      else if (action === 'recharge') this.rechargeDialog();
      else if (action === 'customer-pay') this.payCustomerRecharge();
      else if (action === 'customer-amount') {
        if (this.customerState) return;
        this.amount = Number(button.dataset.amount);
        this.$('[data-customer-custom]').value = String(this.amount);
        this.querySelectorAll('[data-action="customer-amount"]').forEach((item) =>
          item.classList.toggle('active', item === button)
        );
        this.updateCustomerAmount();
      } else if (action === 'recharge-submit') this.submit('recharge');
      else if (action === 'checkout') this.addAllToShopifyCart();
    }
  }

  customElements.define('rr-daily-meals', RRWalletOrdering);
})();

function generateWeeklyMealWeeks() {
  rrPopulateDailySchedule();
}

function rrShowDailySchedule() {
  document.body.classList.add('rr-daily-schedule-active');
  if (!document.querySelector('#rr-daily-schedule-css')) {
    const style = document.createElement('style');
    style.id = 'rr-daily-schedule-css';
    style.textContent = 'body.rr-daily-schedule-active .instant-delivery-option,body.rr-daily-schedule-active .preorder-delivery-option,body.rr-daily-schedule-active #instantOrderClosedMessage,body.rr-daily-schedule-active .normal-delivery-fields{display:none!important}';
    document.head.append(style);
  }
  $('#instantDelivery').prop('checked', false).prop('disabled', true);
  $('#preOrderDelivery').prop('checked', true);
  $('#scheduleFields').stop(true, true).show();
  $('#deliveryDate, #deliveryTime').prop('required', false).val('');
  const parent = document.querySelector('#scheduleFields') || document.querySelector('.delivery-schedule-box');
  if (!parent) return;
  let fields = document.querySelector('#weeklyMealTimeFields');
  if (!fields) { fields = document.createElement('div'); fields.id = 'weeklyMealTimeFields'; }
  if (fields.parentElement !== parent) parent.append(fields);
  fields.style.display = 'block';
  function ensure(id, label) {
    let el = document.getElementById(id);
    if (el?.tagName === 'SELECT') return el;
    const select = document.createElement('select');
    select.id = id;
    select.style.cssText = 'width:100%;padding:12px;border:1px solid #eadfcd;border-radius:6px;background:white;color:inherit;margin-top:6px';
    if (el) el.replaceWith(select);
    else {
      const wrap = document.createElement('label'); wrap.textContent = label;
      wrap.style.cssText = 'display:block;margin:12px 0';wrap.append(select);fields.append(wrap);
    }
    return select;
  }
  ensure('weeklyDeliveryDate', 'Delivery week');
  ensure('weeklyLunchTime', 'Lunch delivery time');
  ensure('weeklyDinnerTime', 'Dinner delivery time');
  $('#weeklyDeliveryDate, #weeklyLunchTime, #weeklyDinnerTime').prop('required', true);
  rrPopulateDailySchedule();
}

function rrPopulateDailySchedule() {
  const cart = rrDailyScheduleCart;
  if (!cart) return;
  const fmt = d => new Intl.DateTimeFormat('en-IN', {day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(d);
  const weeks = new Map();
  for (const item of cart.items) {
    const raw = item.properties?.['Delivery date'];
    if (!/^\d{4}-\d{2}-\d{2}$/.test(raw || '')) continue;
    const date = new Date(raw+'T00:00:00Z');
    if (!Number.isFinite(date.getTime())) continue;
    date.setUTCDate(date.getUTCDate()-date.getUTCDay());
    const end = new Date(date);end.setUTCDate(end.getUTCDate()+6);
    weeks.set(date.toISOString().slice(0,10),fmt(date)+' – '+fmt(end));
  }
  const week = document.getElementById('weeklyDeliveryDate');
  if (week) {
    const old = week.value;
    week.replaceChildren(new Option('Choose delivery week',''));
    for (const [value,label] of [...weeks].sort()) week.add(new Option(label,value));
    if (weeks.has(old)) week.value=old;
    else if (weeks.size===1) week.value=[...weeks.keys()][0];
    if (weeks.size>1) $('#deliveryScheduleMessage').text('Your cart spans multiple weeks. Order one week at a time.').css('color','#FF4F00');
  }
  for (const [id,lunch] of [['weeklyLunchTime',true],['weeklyDinnerTime',false]]) {
    const select=document.getElementById(id);if(!select)continue;
    // Preserve existing merchant-configured weekly slots.
    if ([...select.options].some(o=>o.value)) continue;
    select.replaceChildren(new Option(lunch?'Choose lunch time':'Choose dinner time',''));
    const slots=window.deliverySlotsFromTheme||[];
    for(const slot of slots) {
      const start=Number(slot.start);
      if(!Number.isFinite(start)||!slot.value)continue;
      if(lunch ? start>=15*60 : start<15*60)continue;
      select.add(new Option(slot.label||slot.value,slot.value));
    }
  }
}